{
	"dialog.ok": "Ok",
	"dialog.cancel": "Avbryt",
	"dialog.confirm": "Bekräfta",
	"dialog.close": "Stäng",
	"dialog.import": "Importera",
	"dialog.save": "Spara",
	"dialog.discard": "Släng",
	"dialog.dontshowagain": "Visa inte igen",
	"data.cube": "Kub",
	"data.group": "Grupp",
	"data.texture": "Textur",
	"data.plugin": "Tilläggsprogram",
	"data.preview": "Förhandsvisa",
	"data.toolbar": "Verktygsfält",
	"data.image": "Bild",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Skift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Radera",
	"keys.space": "Mellanslag",
	"keys.leftclick": "Vänsterklick",
	"keys.middleclick": "Mittenklick",
	"keys.rightclick": "Högerklick",
	"keys.tab": "Tab",
	"keys.backspace": "Bakslag",
	"keys.enter": "Retur",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Knappsats %0",
	"keys.caps": "Versallås",
	"keys.menu": "Kontextmeny",
	"keys.left": "Vänster",
	"keys.up": "Upp",
	"keys.right": "Höger",
	"keys.down": "Ner",
	"keys.pageup": "Sida upp",
	"keys.pagedown": "Sida ner",
	"keys.plus": "Plus",
	"keys.comma": "Komma",
	"keys.point": "Punkt",
	"keys.minus": "Minus",
	"keys.cross": "Kryss",
	"keys.end": "Slut",
	"keys.pos1": "Position 1",
	"keys.printscreen": "Skärmbild",
	"keys.pause": "Paus",
	"message.rotation_limit.title": "Rotationsgränser",
	"message.rotation_limit.message": "Roteringar är begränsade av Minecraft till en axel. Rotering av en annan axel rensar alla andra rotationer på de andra axlarna. Konvertera modellen till en \"Generisk modell\" om du modellerar för andra ändamål och behöver fria rotationer.",
	"message.file_not_found.title": "Hittade inte filen",
	"message.file_not_found.message": "Blockbench kunde inte hitta den begärda filen. Försäkra dig att den är sparad lokalt och inte i molnet.",
	"message.screenshot.title": "Skärmbild",
	"message.screenshot.clipboard": "Urklipp",
	"message.screenshot.right_click": "Högerklicka eller tryck länge på skärmbilden för att kopiera",
	"message.invalid_file.title": "Ogiltig fil",
	"message.invalid_file.message": "Kunde inte öppna JSON-filen: %0",
	"message.invalid_model.title": "Ogiltig modellfil",
	"message.invalid_model.message": "Filen innehåller inte giltig modellinformation.",
	"message.child_model_only.title": "Tom delmodell",
	"message.child_model_only.message": "Denna filen är en delmodell av %0 och innehåller inte en modell.",
	"message.unsaved_textures.title": "Osparade texturer",
	"message.unsaved_textures.message": "Din modell har osparade texturer. Kom ihåg att spara dem och att lägga in dem i ditt resurspaket i rätt mapp.",
	"message.model_clipping.title": "För stor modell",
	"message.model_clipping.message": "Din modell innehåller %0 kuber som är större än blockgränsen som tillåts av Minecraft. Den här modellen kommer inte fungera i Minecraft.",
	"message.loose_texture.title": "Importera texturer",
	"message.loose_texture.message": "Den importerade texturen finns inte i ett resurspaket. Minecraft kan endast ladda texturer som finns inuti texturmappen i det laddade resurspaketet.",
	"message.loose_texture.change": "Ändra sökväg",
	"message.update_res.title": "Texturupplösning",
	"message.update_res.message": "Vill du uppdatera projektupplösningen till upplösningen av denna texturen? Klicka 'Avbryt' om din textur har en större upplösning än normalt.",
	"message.update_res.update": "Uppdatera",
	"message.bedrock_overwrite_error.message": "Blockbench kan inte slå ihop denna modellen med en gammal fil",
	"message.bedrock_overwrite_error.backup_overwrite": "Gör en säkerhetskopiering och skriv över",
	"message.bedrock_overwrite_error.overwrite": "Skriv över",
	"message.close_warning.message": "Vill du spara din modell?",
	"message.close_warning.web": "Ditt nuvarande arbete kommer att försvinna. Är du säker att du vill avsluta?",
	"message.default_textures.title": "Standardtexturer",
	"message.default_textures.message": "Välj \"textur\"-mappen i standardresurspaketet",
	"message.default_textures.detail": "Extrahera standardresurspaketet från Minecraft .jar filen eller googla och ladda ner det. Lokalisera sedan \"textur\"-mappen och öppna den. Blockbench kommer ihåg den platsen och kommer att försöka hämta texturer därifrån om den inte kan hitta dem i det aktuella resurspaketet.",
	"message.default_textures.select": "Välj standard \"textur\"-mapp",
	"message.image_editor.title": "Välj en bildredigerare",
	"message.image_editor.file": "Välj fil...",
	"message.image_editor.exe": "Välj en exekverbar bildredigerare",
	"message.display_skin.title": "Minecraft utseende",
	"message.display_skin.message": "Välj en skinfil från din dator eller ange ett spelarnamn",
	"message.display_skin.upload": "Välj fil",
	"message.display_skin.reset": "Återställ",
	"message.invalid_plugin": "Ogiltig plugin fil, se konsolen",
	"message.load_plugin_app": "Vill du tillåta detta tilläggsprogram att göra ändringar på din dator? Använd bara tilläggsprogram från utvecklare du litar på.",
	"message.load_plugin_web": "Vill du ladda detta tilläggsprogram? Använd bara tilläggsprogram från utvecklare du litar på.",
	"message.preset_no_info": "Förinställningen innehåller ingen information för denna plats",
	"message.restart_to_update": "Starta om Blockbench för att tillämpa ändringar",
	"message.save_file": "Sparad som %0",
	"dialog.project.title": "Projekt",
	"dialog.project.name": "Filnamn",
	"dialog.project.parent": "Modermodell",
	"dialog.project.geoname": "Modellidentifierare",
	"dialog.project.ao": "Omgivande ocklusion",
	"dialog.texture.title": "Textur",
	"dialog.texture.variable": "Variabel",
	"dialog.texture.namespace": "Namnrymd",
	"dialog.texture.folder": "Mapp",
	"dialog.extrude.title": "Ta bort bild",
	"dialog.extrude.mode": "Skanningsläge",
	"dialog.extrude.mode.areas": "Områden",
	"dialog.extrude.mode.lines": "Linjer",
	"dialog.extrude.mode.columns": "Kolumner",
	"dialog.extrude.mode.pixels": "Pixlar",
	"dialog.extrude.opacity": "Minsta opacitet",
	"dialog.extrude.scan": "Skanna och importera",
	"dialog.display_preset.title": "Skapa förinställning",
	"dialog.display_preset.message": "Välj platserna du vill spara",
	"dialog.display_preset.create": "Skapa",
	"dialog.select.title": "Välj",
	"dialog.select.group": "I vald grupp",
	"dialog.select.name": "Namnet inehåller",
	"dialog.select.random": "Slumpmässig chans (%)",
	"dialog.select.select": "Välj",
	"dialog.scale.title": "Skala modellen",
	"dialog.scale.axis": "Axel",
	"dialog.scale.clipping": "Modellklippning: Din modell är för stor för kanvasen",
	"dialog.scale.confirm": "Skala",
	"dialog.plugins.title": "Plugin",
	"dialog.plugins.installed": "Installerade",
	"dialog.plugins.available": "Tillgängliga",
	"dialog.plugins.install": "Installera",
	"dialog.plugins.uninstall": "Avinstallera",
	"dialog.plugins.reload": "Ladda om",
	"dialog.plugins.none_installed": "Inga installerade plugins",
	"dialog.plugins.none_available": "Inga tillgängliga plugins",
	"dialog.plugins.web_only": "Endast för webappen",
	"dialog.plugins.app_only": "Endast för skrivbordsappen",
	"dialog.plugins.author": "av %0",
	"dialog.create_texture.folder": "Mapp",
	"dialog.create_texture.resolution": "Upplösning",
	"dialog.input.title": "Inmatning",
	"dialog.settings.settings": "Inställningar",
	"dialog.settings.keybinds": "Tangentbindningar",
	"dialog.settings.about": "Om",
	"layout.color.back": "Tillbaka",
	"layout.color.back.desc": "Bakgrund och inmatningsfält",
	"layout.color.dark": "Mörkt",
	"layout.color.dark.desc": "Kanvasbakgrund",
	"layout.color.ui": "Användargränssnitt",
	"layout.color.ui.desc": "Huvudgränssnittets färg",
	"layout.color.bright_ui": "Ljust gränssnitt",
	"layout.color.bright_ui.desc": "Kontextmenyer och verktygstips",
	"layout.color.button": "Knapp",
	"layout.color.button.desc": "Knappar och brytare",
	"layout.color.selected": "Vald",
	"layout.color.selected.desc": "Valda flikar och objekt",
	"layout.color.border": "Kant",
	"layout.color.border.desc": "Kant för knappar och inputs",
	"layout.color.accent": "Accent",
	"layout.color.accent.desc": "Skjutreglage och andra detaljer",
	"layout.color.grid": "Rutnät",
	"layout.color.grid.desc": "3D förhandsgranskningsnät",
	"layout.color.text": "Text",
	"layout.color.text.desc": "Normal text",
	"layout.color.light": "Ljust",
	"layout.color.light.desc": "Framhävd text",
	"layout.color.accent_text": "Accent Text",
	"layout.color.accent_text.desc": "Text på accentbakgrunder",
	"layout.font.main": "Huvudtypsnitt",
	"layout.font.headline": "Rubrikstypsnitt",
	"about.version": "Version:",
	"settings.category.general": "Allmän",
	"settings.category.preview": "Förhansvisning",
	"settings.category.grid": "Rutnät",
	"settings.category.edit": "Redigera",
	"settings.category.snapping": "Snappning",
	"settings.category.defaults": "Standarder",
	"settings.category.dialogs": "Dialoger",
	"settings.category.export": "Exportera",
	"settings.language": "Språk",
	"settings.language.desc": "Gränssnittsspråk",
	"settings.backup_interval": "Säkerhetskopierings intervall",
	"settings.backup_interval.desc": "Intervall av den automatiska säkerhetskopieringen i minuter",
	"settings.origin_size": "Vridpunkts Markör",
	"settings.origin_size.desc": "Storlek på vridpunktsmarkören",
	"settings.control_size": "Axlarnas kontroll storlek",
	"settings.control_size.desc": "Storleken på den tredje axelns kontroll verktyg",
	"settings.display_skin": "Minecraft utseende",
	"settings.display_skin.desc": "Skinn använt för att visa referens spelarmodellen",
	"settings.shading": "Skuggning",
	"settings.shading.desc": "Aktivera skuggning",
	"settings.base_grid": "Litet rutnät",
	"settings.base_grid.desc": "Visa litet rutnät och axlar",
	"settings.large_grid": "Block-rutnät",
	"settings.large_grid.desc": "Visa 16x16 block-rutnät",
	"settings.full_grid": "Exakt block-rutnät",
	"settings.full_grid.desc": "Visa pixel-exakt block-rutnät",
	"settings.large_box": "Stor låda",
	"settings.large_box.desc": "Visa storleksgränser",
	"settings.display_grid": "Visningsläge",
	"settings.display_grid.desc": "Visa rutnät i visningsläget",
	"settings.undo_limit": "Ångrings gräns",
	"settings.undo_limit.desc": "Antal steg du kan ångra",
	"settings.local_move": "Flytta på relativa axlar",
	"settings.local_move.desc": "Flytta roterade element på dess egna axlar om möjligt",
	"settings.canvas_unselect": "Avmarkera alla element",
	"settings.canvas_unselect.desc": "Avmarkera alla element när du klickar på kanvasbakgrunden",
	"settings.paint_side_restrict": "Begränsa pensel till sida",
	"settings.paint_side_restrict.desc": "Begränsa penslar till att bara måla på den nuvarande sidan",
	"settings.autouv": "Auto UV",
	"settings.autouv.desc": "Aktivera Auto UV som standard",
	"settings.create_rename": "Byt namn på ny kub",
	"settings.create_rename.desc": "Foksuera på namnfältet när du skapar nya element eller grupper",
	"settings.edit_size": "Rutnäts upplösning",
	"settings.edit_size.desc": "Upplösning på rutnätet som kuber kan fästa till",
	"settings.shift_size": "Shift upplösning",
	"settings.shift_size.desc": "Upplösning av rutnätet medan du håller ner skift",
	"settings.ctrl_size": "Kontrollupplösning",
	"settings.ctrl_size.desc": "Upplösning av rutnätet medan du håller ner ctrl",
	"settings.negative_size": "Negativ storlek",
	"settings.negative_size.desc": "Tillåt skalningsverktyget att använda negativa storlekar",
	"settings.minifiedout": "Förminskad export",
	"settings.minifiedout.desc": "Skriv JSON-filer på en rad",
	"settings.export_groups": "Exportera grupper",
	"settings.export_groups.desc": "Spara grupper i block- eller objektmodell filerna",
	"settings.credit": "Krediterandekommentar",
	"settings.credit.desc": "Lägg till medverkande kommentar till exporterade filer",
	"settings.default_path": "Standardsökväg för Minecraft-texturer",
	"settings.default_path.desc": "Mapp där Blockbench laddar standardtexturer",
	"settings.image_editor": "Bildredigerare",
	"settings.image_editor.desc": "Standard bildredigerare att redigera texturer med",
	"category.navigate": "Navigering",
	"category.tools": "Verktyg",
	"category.file": "Fil",
	"category.blockbench": "Blockbench",
	"category.edit": "Redigera",
	"category.transform": "Omvandla",
	"category.view": "Visa",
	"category.display": "Skärminställningar",
	"category.textures": "Texturer",
	"category.misc": "Diverse",
	"keybind.preview_select": "Välj",
	"keybind.preview_rotate": "Rotera vy",
	"keybind.preview_drag": "Dra vy",
	"keybind.confirm": "Tillämpa",
	"keybind.cancel": "Avbryt",
	"action.slider_inflate": "Blåsa upp",
	"action.slider_inflate.desc": "Blås upp kuber i alla riktningar utan att ändra UV.",
	"action.slider_brush_size": "Storlek",
	"action.slider_brush_size.desc": "Penselns radie i pixlar",
	"action.slider_brush_opacity": "Opacitet",
	"action.slider_brush_opacity.desc": "Penselns opacitet i procent",
	"action.slider_brush_softness": "Mjukhet",
	"action.slider_brush_softness.desc": "Penselns mjukhet i procent",
	"action.uv_slider_pos_x": "Flytta horisontellt",
	"action.uv_slider_pos_x.desc": "Flytta alla markerade UV-ytor horisontellt",
	"action.uv_slider_pos_y": "Flytta vertikalt",
	"action.uv_slider_pos_y.desc": "Flytta alla markerade UV-ytor vertikalt",
	"action.uv_slider_size_x": "Horisontell storlek",
	"action.uv_slider_size_x.desc": "Ändra storlek på alla markerade UV-ytor horisontellt",
	"action.uv_slider_size_y": "Vertikal storlek",
	"action.uv_slider_size_y.desc": "Ändra storlek på alla markerade UV-ytor vertikalt",
	"action.vertex_snap_mode": "Snap-läge",
	"action.vertex_snap_mode.desc": "Välj om Vertex Snap flyttar element till det valda läget eller ändrar dem",
	"action.move_tool": "Flytta",
	"action.move_tool.desc": "Verktyg för att flytta element",
	"action.resize_tool": "Ändra storlek",
	"action.resize_tool.desc": "Verktyg för att ändra storlek på element",
	"action.brush_tool": "Målarpensel",
	"action.brush_tool.desc": "Verktyg för att måla på bitmaptexturer på ytor eller UV redigeraren",
	"action.vertex_snap_tool": "Nod-Snap",
	"action.vertex_snap_tool.desc": "Flytta en kub till en annan kub genom att koppla samman två hörn",
	"action.swap_tools": "Byt verktyg",
	"action.swap_tools.desc": "Växla mellan flytt och storleks verktygen",
	"action.project_window": "Projekt...",
	"action.project_window.desc": "Öppnar projektfönstret, där du kan redigera metadata för din modell",
	"action.open_model": "Öppna modell",
	"action.open_model.desc": "Öppna en modellfil från din dator",
	"action.extrude_texture": "Extruderad textur",
	"action.extrude_texture.desc": "Generera en modell genom att sträcka ut en textur",
	"action.export_blockmodel": "Exportera block-/objekt modell",
	"action.export_blockmodel.desc": "Exportera ett Minecraft block- eller objektmodell",
	"action.export_optifine_part": "Exportera OptiFine-del",
	"action.export_optifine_part.desc": "Exportera en entitetdelmodell för OptiFine",
	"action.export_optifine_full": "Exportera OptiFine JEM",
	"action.export_optifine_full.desc": "Exportera en hel OptiFine enititymodell",
	"action.export_obj": "Exportera OBJ modell",
	"action.export_obj.desc": "Exportera en Wavefront OBJ modell för rendering eller spelmotorer",
	"action.settings_window": "Inställningar...",
	"action.settings_window.desc": "Öppna Blockbenchs inställningsdialogruta.",
	"action.plugins_window": "Plugins...",
	"action.plugins_window.desc": "Öppna pluginaffärfönstret",
	"action.reset_layout": "Återställ layout",
	"action.reset_layout.desc": "Återställ layouten till Blockbenchs standardlayout",
	"action.load_plugin": "Ladda plugin från fil",
	"action.load_plugin.desc": "Ladda ett tilläggsprogram genom att importera källfilen",
	"action.reload_plugins": "Ladda om plugins",
	"action.reload_plugins.desc": "Ladda om alla utvecklingsplugins",
	"action.undo": "Ångra",
	"action.undo.desc": "Ångrar den senaste ändringen",
	"action.redo": "Gör om",
	"action.redo.desc": "Gör om den senaste ångringen",
	"action.copy": "Kopiera",
	"action.copy.desc": "Kopiera det valda urvalet, yta eller bildskärmsinställningarna",
	"action.paste": "Klistra in",
	"action.paste.desc": "Klistra in det valda urvalet, yta eller bildskärmsinställningarna",
	"action.cut": "Klipp ut",
	"action.cut.desc": "Klipp ut det valda urvalet, yta eller bildskärmsinställningarna",
	"action.add_cube": "Lägg till en kub",
	"action.add_cube.desc": "Lägger till en ny kub",
	"action.add_group": "Lägg till en grupp",
	"action.add_group.desc": "Lägger till en ny grupp eller ben",
	"action.outliner_toggle": "Växla fler alternativ",
	"action.outliner_toggle.desc": "Växla knappar för mer alternativ i konturen",
	"action.duplicate": "Duplicera",
	"action.delete": "Radera",
	"action.sort_outliner": "Sortera konturer",
	"action.sort_outliner.desc": "Sortera konturen alfabetiskt",
	"action.select_window": "Välj...",
	"action.select_window.desc": "Sök och välj kuber baserat på deras egenskaper",
	"action.invert_selection": "Invertera valet",
	"action.invert_selection.desc": "Invertera det nuvarande valet av kuber",
	"action.select_all": "Välj alla",
	"action.collapse_groups": "Kollapsa grupper",
	"action.collapse_groups.desc": "Kollapsa alla grupper",
	"action.scale": "Skala...",
	"action.scale.desc": "Skala valda kuber",
	"action.toggle_visibility": "Växla synlighet",
	"action.toggle_visibility.desc": "Växla synlighet för de valda kuberna.",
	"action.toggle_export": "Växla export",
	"action.toggle_export.desc": "Växla exportinställningarna för de valda kuberna.",
	"action.toggle_autouv": "Växla Auto UV",
	"action.toggle_autouv.desc": "Växla Auto UV inställningar för de valda kuberna.",
	"action.toggle_shade": "Växla skuggning",
	"action.toggle_shade.desc": "Växla skuggningen för de valda kuberna.",
	"action.rename": "Byt namn",
	"action.rename.desc": "Byta namn för de valda kuberna.",
	"action.add_display_preset": "Ny förinställning",
	"action.add_display_preset.desc": "Lägg till en ny förinställd skärminställning.",
	"action.fullscreen": "Helskärm",
	"action.fullscreen.desc": "Växlar helskärmsläget",
	"action.zoom_in": "Zooma in",
	"action.zoom_in.desc": "Zooma in för att skala upp gränssnittet",
	"action.zoom_out": "Zooma ut",
	"action.zoom_out.desc": "Zooma ut för att skala ner gränssnittet",
	"action.zoom_reset": "Återställ zoom",
	"action.zoom_reset.desc": "Återställ zoom till 100%.",
	"action.reset_interface": "Återställ gränssnitt",
	"action.reset_interface.desc": "Återställ storlek och positioner för GUI",
	"action.screenshot_model": "Skärmbildsmodell",
	"action.screenshot_model.desc": "Ta en klippt skärmbild av modellen från den nuvarande vinkeln.",
	"action.screenshot_app": "Skärmbildsapp",
	"action.screenshot_app.desc": "Ta en skärmbild av hela applikationen.",
	"action.import_texture": "Importera textur",
	"action.import_texture.desc": "Importera en eller fler texturer från ditt filsystem.",
	"action.create_texture": "Gör en textur",
	"action.create_texture.desc": "Skapa en tom textur eller malltextur",
	"action.save_textures": "Spara texturer",
	"action.save_textures.desc": "Spara alla osparade texturer",
	"action.animated_textures": "Spela animerade texturer",
	"action.animated_textures.desc": "Spela och pausa förhandsvisningen av animerade texturer",
	"action.origin_to_geometry": "Centera Vridning",
	"action.origin_to_geometry.desc": "Ställ vridpunkten till mitten av valet",
	"action.bone_reset_toggle": "Återställ ben",
	"action.bone_reset_toggle.desc": "Stoppa benet från att visa kuber från modermodellen",
	"action.reload": "Ladda om Blockbench",
	"action.reload.desc": "Ladda om Blockbench. Detta tar bort alla osparade ändringar.",
	"menu.file": "Fil",
	"menu.edit": "Redigera",
	"menu.transform": "Transformera",
	"menu.display": "Visa",
	"menu.view": "Vy",
	"menu.file.new": "Ny",
	"menu.file.recent": "Nyligen",
	"menu.file.import": "Importera",
	"menu.file.export": "Exportera",
	"menu.transform.rotate": "Rotera",
	"menu.transform.flip": "Vänd",
	"menu.transform.center": "Center",
	"menu.transform.properties": "Egenskaper",
	"menu.display.preset": "Tillämpa förinställning",
	"menu.display.preset_all": "Tillämpa förinställning överallt",
	"menu.display.remove_preset": "Ta bort förinställning",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Bakgrund",
	"menu.view.screenshot": "Skärmbild",
	"menu.cube.color": "Markör färg",
	"menu.cube.texture": "Textur",
	"menu.cube.texture.transparent": "Genomskinlig",
	"menu.cube.texture.blank": "Tom",
	"menu.group.sort": "Sortera",
	"menu.texture.face": "Applicera på yta",
	"menu.texture.file": "Fil",
	"menu.texture.refresh": "Ladda om",
	"menu.texture.change": "Ändra fil",
	"menu.texture.folder": "Öppna i mapp",
	"menu.texture.edit": "Redigera",
	"menu.texture.export": "Spara som",
	"menu.texture.save": "Spara",
	"menu.texture.properties": "Egenskaper",
	"menu.preview.background": "Bakgrund",
	"menu.preview.background.load": "Ladda",
	"menu.preview.background.position": "Position",
	"menu.preview.background.lock": "Lås till kamera",
	"menu.preview.screenshot": "Skärmbild",
	"menu.preview.perspective": "Perspektiv",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Fyrvy",
	"menu.preview.stop_drag": "Stoppa bakgrundspositionering",
	"menu.uv.mapping.rotation": "Rotation",
	"menu.uv.texture": "Textur",
	"cube.color.light_blue": "Ljus blå",
	"cube.color.yellow": "Gul",
	"cube.color.orange": "Orange",
	"cube.color.red": "Röd",
	"cube.color.purple": "Lila",
	"cube.color.blue": "Blå",
	"cube.color.green": "Grön",
	"cube.color.lime": "Lime",
	"switches.visibility": "Synlighet",
	"switches.export": "Exportera",
	"switches.autouv": "Auto UV",
	"panel.uv": "UV",
	"panel.display": "Visa",
	"panel.textures": "Texturer",
	"panel.outliner": "Konturen",
	"uv_editor.title": "UV redigerare",
	"uv_editor.all_faces": "Alla",
	"uv_editor.no_faces": "Ingen",
	"face.north": "Norr",
	"face.south": "Söder",
	"face.west": "Väster",
	"face.east": "Öster",
	"face.up": "Upp",
	"face.down": "Ner",
	"direction.north": "Norr",
	"direction.south": "Söder",
	"direction.west": "Väster",
	"direction.east": "Öster",
	"direction.top": "Topp",
	"direction.bottom": "Botten",
	"display.slot.third_right": "Tredje person höger",
	"display.slot.third_left": "Tredje person vänster",
	"display.slot.first_right": "Första person höger",
	"display.slot.first_left": "Första person vänster",
	"display.slot.head": "Huvud",
	"display.slot.ground": "Mark",
	"display.slot.frame": "Ram",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotation",
	"display.translation": "Översättning",
	"display.scale": "Skala",
	"display.slot": "Plats",
	"display.reference": "Referensmodell",
	"display.reference.player": "Spelare",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Rustningsställ",
	"display.reference.baby_zombie": "Bäbis zombie",
	"display.reference.armor_stand_small": "Litet rustningsställ",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Laddad pilbåge",
	"display.reference.block": "Block",
	"display.reference.frame": "Föremålsram",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Inventarium",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Ange ett namn",
	"display.preset.item": "Standardobjekt",
	"display.preset.block": "Standard block",
	"display.preset.handheld": "Standard vapen",
	"display.preset.rod": "Standard spö",
	"dialog.continue": "Fortsätt",
	"message.square_textures": "Texturer måste vara fyrkantiga",
	"message.unsaved_texture.title": "Osparad textur",
	"message.unsaved_texture.message": "Alla osparade ändringar till denna textur kommer att försvinna. Vill du fortsätta?",
	"action.vertex_snap_mode.move": "Flytta",
	"action.vertex_snap_mode.scale": "Skala",
	"action.open_model_folder": "Öppna modellmapp",
	"action.open_model_folder.desc": "Öppnar mappen som modellen finns i",
	"action.change_textures_folder": "Ändra texturposition",
	"action.change_textures_folder.desc": "Ändra mapp som alla texturer sparas i",
	"menu.texture.particle": "Använd för partiklar",
	"message.update_notification.title": "En uppdatering är tillgänglig ",
	"message.update_notification.message": "En ny Blockbench-version är tillgänglig. Aktivera automatiska uppdateringar i inställningarna för att uppdatera!",
	"message.untextured": "Denna ytan har ingen textur",
	"dialog.toolbar_edit.title": "Anpassa verktygsfältet",
	"keybindings.reset": "Återställ",
	"keybindings.clear": "Tom",
	"action.cube_counter": "Modellstatistik",
	"action.uv_rotation": "UV rotation",
	"action.uv_rotation.desc": "Rotation av UV ytan",
	"action.uv_grid": "UV rutnät",
	"action.uv_grid.desc": "Upplösningen av rutnätet som UV väljaren snäpper till",
	"action.uv_grid.auto": "Auto",
	"action.uv_maximize": "Maximera UV",
	"action.uv_maximize.desc": "Ställer in UV för denna ytan till den fulla texturen",
	"action.uv_auto": "Auto UV",
	"action.uv_auto.desc": "Ställer in UV för denna ytan till den riktiga storleken av ytan",
	"action.uv_rel_auto": "Relativ Auto UV",
	"action.uv_rel_auto.desc": "Ställer in UV för denna ytan till positionen och storleken av den faktiska ytan",
	"action.uv_mirror_x": "UV spegla X",
	"action.uv_mirror_x.desc": "Speglar UV i denna ytan på X axeln",
	"action.uv_mirror_y": "UV spegla Y",
	"action.uv_mirror_y.desc": "Speglar UV i denna ytan på Y axeln",
	"action.uv_transparent": "Transparent yta",
	"action.uv_transparent.desc": "Gör den nuvarande ytan transparent",
	"action.uv_reset": "Återställ yta",
	"action.uv_reset.desc": "Återställer den nuvarande ytan",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Inaktiverar rendering av denna ytan om den valda sidan av modellen är täckt",
	"action.auto_cullface": "Auto cullface",
	"action.auto_cullface.desc": "Sätter cullface för denna ytan till sig själv",
	"action.face_tint": "Nyans",
	"action.face_tint.desc": "Aktiverar nyans alternativet för den aktuella ytan",
	"menu.toolbar.edit": "Anpassa verktygsfält",
	"menu.toolbar.reset": "Återställ verktygsfält",
	"uv_editor.rotated": "Roterade",
	"uv_editor.auto_cull": "Cullface till sig själv",
	"uv_editor.copied": "Kopierade ytan",
	"uv_editor.pasted": "Klistrande in ytan",
	"uv_editor.copied_x": "Kopierade %0 ytor",
	"uv_editor.reset": "Återställ yta",
	"uv_editor.maximized": "Maximerad",
	"uv_editor.autouv": "Auto storlek",
	"uv_editor.mirrored": "Speglad",
	"uv_editor.to_all": "Applicerad på alla ytor",
	"uv_editor.transparent": "Gjord genomskinlig",
	"uv_editor.cullface_on": "Cullface på",
	"uv_editor.cullface_off": "Cullface av",
	"uv_editor.tint_on": "Nyans på",
	"uv_editor.tint_off": "Nyans av",
	"action.uv_apply_all": "Applicera på alla ytor",
	"action.uv_apply_all.desc": "Applicera inställningarna från den nuvarande ytan till alla ytor",
	"message.image_editor_missing.title": "Standard bildredigerare",
	"message.image_editor_missing.message": "Välj den körbara filen för din bildredigerare",
	"message.image_editor_missing.detail": "Blockbench kunde inte hitta någon bildredigerare på din dator. Välj den körbara filen för din föredragna bildredigerare.",
	"action.update_autouv": "Uppdatera Auto UV",
	"action.update_autouv.desc": "Uppdatera Auto UV kartläggning för de valda kuberna",
	"category.uv": "UV",
	"status_bar.saved": "Modellen är sparad",
	"status_bar.unsaved": "Det finns osparade ändringar",
	"action.move_up": "Flytta upp",
	"action.move_up.desc": "Flytta de valda kuberna upp relativt till den nuvarande kameravinkeln",
	"action.move_down": "Flytta ner",
	"action.move_down.desc": "Flytta de valda kuberna ner relativt till den nuvarande kameravinkeln",
	"action.move_left": "Flytta vänster",
	"action.move_left.desc": "Flytta de valda kuberna vänster relativt till den nuvarande kameravinkeln",
	"action.move_right": "Flytta höger",
	"action.move_right.desc": "Flytta de valda kuberna höger relativt till den nuvarande kameravinkeln",
	"action.move_forth": "Flytta framåt",
	"action.move_forth.desc": "Flytta de valda kuberna framåt relativt till den nuvarande kameravinkeln",
	"action.move_back": "Flytta bakåt",
	"action.move_back.desc": "Flytta de valda kuberna bakåt relativt till den nuvarande kameravinkeln",
	"layout.color.wireframe": "Wireframe",
	"layout.color.wireframe.desc": "Visa wireframe linjer",
	"action.add_animation": "Lägg till animation",
	"action.add_animation.desc": "Skapa en tom animation",
	"action.load_animation_file": "Importera animationer",
	"action.load_animation_file.desc": "Importera en animationsfil",
	"action.play_animation": "Spela animationer",
	"action.play_animation.desc": "Förhandsgranska den valda animationen",
	"action.slider_keyframe_time": "Tidskod",
	"action.slider_keyframe_time.desc": "Ändra tidskoden för de valda nyckelbilderna",
	"timeline.rotation": "Rotation",
	"timeline.position": "Position",
	"timeline.scale": "Skala",
	"menu.keyframe.quaternion": "Kvartärperiod",
	"panel.animations": "Animationer",
	"panel.keyframe": "Nyckelbild",
	"panel.keyframe.type": "Nyckelbild (%0)",
	"generic.delete": "Radera",
	"generic.rename": "Byt namn",
	"message.no_animation_selected": "Du måste välja en animation för att göra detta",
	"message.no_bone_selected": "Du måste välja ett ben för att göra detta",
	"message.duplicate_groups.title": "Ben namn dublett",
	"message.duplicate_groups.message": "Benets namn finns på flera ben. Detta kan orsaka problem.",
	"action.delete_keyframes": "Radera nyckelbilder",
	"action.delete_keyframes.desc": "Radera alla valda nyckelbilder",
	"menu.animation": "Animation",
	"menu.animation.loop": "Loopläge",
	"menu.animation.override": "Åsidosätta",
	"menu.animation.anim_time_update": "Uppdatera variabel",
	"message.display_skin_model.title": "Skinmodell",
	"message.display_skin_model.message": "Välj modell typ för ditt skin",
	"message.display_skin_model.classic": "Klassisk",
	"message.display_skin_model.slim": "Smal",
	"message.bone_material": "Ändra ben material",
	"action.slider_animation_length": "Animationslängd",
	"action.slider_animation_length.desc": "Ändra längden av den valda animationen",
	"panel.variable_placeholders": "Platshållare variabel",
	"status_bar.vertex_distance": "Distans: %0",
	"dialog.create_gif.title": "Spela in GIF",
	"dialog.create_gif.length": "Längd",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Starta animationen",
	"category.animation": "Animation",
	"action.record_model_gif": "Spela in GIF...",
	"action.record_model_gif.desc": "Spela in en animerad GIF av modellen från den nuvarande vinkeln",
	"display.mirror": "Spegla",
	"data.separator": "Seperator",
	"menu.preview.background.set_position": "Sätt position",
	"dialog.toolbar_edit.hidden": "Gömd",
	"action.export_class_entity": "Exportera Java entitet",
	"action.export_class_entity.desc": "Exportera entitymodellen som en Java klass",
	"settings.seethrough_outline": "Röntgenkonturer",
	"settings.seethrough_outline.desc": "Visa konturer genom objekt",
	"mode.edit": "Redigera",
	"mode.paint": "Måla",
	"mode.display": "Visa",
	"mode.animate": "Animera",
	"status_bar.recording_gif": "Spelar in",
	"status_bar.processing_gif": "Bearbetar",
	"settings.backup_retain": "Säkerhetskopierings varaktighet",
	"settings.backup_retain.desc": "Ange hur länge Blockbench behåller gamla säkerhetskopior i dagar",
	"action.rotate_tool": "Rotera",
	"action.rotate_tool.desc": "Verktyg för att välja och rotera element",
	"action.fill_tool": "Målarfärgsburk",
	"action.fill_tool.desc": "Målarhink för att fylla hela ytor med en färg",
	"action.eraser": "Suddgummi",
	"action.eraser.desc": "Suddgummi för att ersätta färger på en textur med genomskinlighet",
	"action.color_picker": "Färgväljare",
	"action.color_picker.desc": "Verktyg för att välja färg på pixlar på din textur",
	"switches.mirror": "Spegla UV",
	"language_name": "Svenska",
	"message.plugin_reload": "Uppdaterade %0 lokala plugins",
	"settings.brightness": "Ljusstyrka",
	"settings.brightness.desc": "Förhandsgranskningens ljusstyrka. Standard är 50",
	"menu.preview.perspective.reset": "Återställ kamera",
	"action.fill_mode": "Fyllningsläge",
	"action.fill_mode.face": "Yta",
	"action.fill_mode.color": "Färger",
	"action.toggle_mirror_uv": "Spegla UV",
	"action.toggle_mirror_uv.desc": "Växla UV-spegling på X axeln för de valda kuberna.",
	"menu.texture.blank": "Applicera på otexturerade Ytor",
	"dialog.scale.select_overflow": "Välj överflöde",
	"action.action_control": "Åtgärdskontroll",
	"action.action_control.desc": "Sök och kör alla tillgängliga åtgärder",
	"keybindings.recording": "Spelar in tangentbindningar",
	"keybindings.press": "Tryck på en knapp eller tangentkombination eller klicka någonstans på skärmen för att spela in din tangentbindning.",
	"action.pivot_tool": "Vridpunkten",
	"action.pivot_tool.desc": "Verktyg för att ändra rotationspunkten för kuber och ben",
	"action.slider_animation_speed": "Uppspelningshastighet",
	"action.slider_animation_speed.desc": "Tidslinjens uppspelningshastighet i procent",
	"action.previous_keyframe": "Föregående nyckelbild",
	"action.previous_keyframe.desc": "Hoppa till föregående nyckelbilden",
	"action.next_keyframe": "Nästa nyckelbild",
	"action.next_keyframe.desc": "Hoppa till nästa nyckelbild",
	"message.outdated_client.title": "Utdaterad klient",
	"message.outdated_client.message": "Vänligen uppdatera till den senaste versionen av Blockbench för att göra detta.",
	"action.export_asset_archive": "Hämta arkiv",
	"action.export_asset_archive.desc": "Ladda ner ett arkiv med modellen och alla texturer i den",
	"action.upload_sketchfab": "Sketchfab uppladdning",
	"message.sketchfab.name_or_token": "Ange din Sketchfab token och ett namn",
	"dialog.sketchfab_uploader.title": "Ladda upp Sketchfabmodell",
	"dialog.sketchfab_uploader.token": "API Token",
	"dialog.sketchfab_uploader.about_token": "Token används för att ansluta Blockbench till ditt Sketchfab konto. Du kan hitta den på %0",
	"dialog.sketchfab_uploader.name": "Modellnamn",
	"dialog.sketchfab_uploader.description": "Beskrivning",
	"dialog.sketchfab_uploader.tags": "Tags",
	"settings.sketchfab_token": "Sketchfab token",
	"settings.sketchfab_token.desc": "Token för att tillåta Blockbench att ladda upp till ditt Sketchfab konto",
	"panel.color": "Färg",
	"data.origin": "Pivotera",
	"message.sketchfab.success": "Laddade upp modellen lyckat",
	"message.sketchfab.error": "Det gick inte att ladda upp modellen till Sketchfab",
	"settings.outliner_colors": "Kontur färger",
	"settings.outliner_colors.desc": "Visa kubfärger i konturerna",
	"action.upload_sketchfab.desc": "Ladda upp din modell till Sketchfab",
	"action.element_colors": "Kubfärg",
	"action.element_colors.desc": "Visa kubfärger i konturerna",
	"texture.error.file": "Filen hittades inte",
	"texture.error.parent": "Texturfil försedd av modermodell",
	"message.recover_backup.title": "Återställ modeller",
	"message.recover_backup.message": "Blockbench stängdes utan att spara. Vill du återställa modellen?",
	"message.invalid_session.title": "Ogiltig session token",
	"message.invalid_session.message": "Den session du försöker gå med i har gått ut eller är den angivna token är ogiltig.",
	"dialog.create_texture.power": "Upphöjt till 2 storlek",
	"dialog.create_gif.turn": "Vridhastighet",
	"action.edit_session": "Redigera session...",
	"action.edit_session.desc": "Anslut till en redigeringssession för att samarbeta med andra användare",
	"action.reset_keyframe": "Återställ nyckelbild",
	"action.reset_keyframe.desc": "Återställ alla värden för de valda nyckelbilder",
	"dialog.edit_session.title": "Redigera session",
	"edit_session.username": "Användarnamn",
	"edit_session.token": "Token",
	"edit_session.about": "Redigeringssessioner kan användas för att samarbeta på modeller över hela internet. Skapa en session och kopiera din token och skicka den till vänner, som kan använda den för att gå med.",
	"edit_session.join": "Gå med i sessionen",
	"edit_session.create": "Skapa session",
	"edit_session.quit": "Lämna session",
	"edit_session.joined": "%0 anslöt till sessionen",
	"edit_session.left": "%0 lämnade sessionen",
	"edit_session.quit_session": "Lämna nuvarande session",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hosting",
	"edit_session.connected": "Ansluten till en session",
	"dialog.sketchfab_uploader.private": "Privat (Pro)",
	"dialog.sketchfab_uploader.password": "Lösenord (Pro)",
	"action.uv_select_all": "Makera alla",
	"action.uv_select_all.desc": "Välj alla ytor i UV-dialogen",
	"panel.chat": "Chatt",
	"edit_session.welcome": "Välkommen till sessionen av %0",
	"dialog.yes": "Ja",
	"dialog.no": "Nej",
	"generic.remove": "Ta bort",
	"generic.download": "Ladda ner",
	"generic.search": "Sök",
	"dates.today": "Idag",
	"dates.yesterday": "Igår",
	"dates.this_week": "Denna veckan",
	"dates.weeks_ago": "%0 veckor sedan",
	"mode.start.new": "Ny",
	"mode.start.recent": "Nyligen",
	"format.free": "Generisk modell",
	"format.free.desc": "Modellera utan restriktioner. För spelmotorer, rendering osv.",
	"format.java_block": "Java Block/Objekt",
	"format.java_block.desc": "Block- eller objektmodell för Minecraft Java Edition.",
	"format.bedrock": "Bedrock-entitet",
	"format.bedrock.desc": "Modell för Minecraft Bedrock Edition",
	"format.bedrock_old": "Äldre Bedrock modell",
	"format.bedrock_old.desc": "Före 1.12 Minecraft Bedrock entitetmodell",
	"format.modded_entity": "Moddad entitet",
	"format.modded_entity.desc": "Entitetmodell för Minecraft mods. Kan exporteras som .java klassfiler.",
	"format.optifine_entity": "OptiFine entitet",
	"format.optifine_entity.desc": "Anpassad entitetmodell för OptiFine-mod",
	"keys.mouse": "Musknapp %0",
	"message.cleared_blank_faces.title": "Tomma Ytor",
	"message.cleared_blank_faces.message": "Blockbench har hittat %0 kuber utan någon textur. Vill du ta bort de elemented?",
	"message.wireframe.enabled": "Wireframe läget aktiverat",
	"message.wireframe.disabled": "Wireframe läget inaktiverat",
	"dialog.convert_project.title": "Konvertera Projekt",
	"dialog.create_texture.double_use": "Keep Multi Texture Occupancy",
	"dialog.model_stats.title": "Modellstatistik",
	"dialog.model_stats.cubes": "Kuber",
	"dialog.model_stats.locators": "Lokaliseringsobjekt",
	"dialog.model_stats.groups": "Grupper",
	"dialog.model_stats.vertices": "Hörn",
	"dialog.model_stats.faces": "Ytor",
	"settings.username": "Användarnamn",
	"settings.username.desc": "Användarnamn för redigeringssessioner",
	"settings.painting_grid": "Målningsrutnät",
	"settings.painting_grid.desc": "Visa rutnätet på kuber med texturer i målnings läge.",
	"action.convert_project": "Konvertera projektet",
	"action.convert_project.desc": "Konverterar det nuvarande projektet till ett projekt för ett annat modellformat.",
	"action.close_project": "Stäng projektet",
	"action.close_project.desc": "Stänger det öppna projektet",
	"action.export_bedrock": "Exportera Bedrock geometri",
	"action.export_bedrock.desc": "Exportera modellen som en Bedrock Edition geometrifil.",
	"action.save_project": "Spara projektet",
	"action.save_project.desc": "Sparar det nuvarande projektet som en projektfil",
	"action.save_project_as": "Spara Projekt Som",
	"action.save_project_as.desc": "Sparar den nuvarande modellen som en projektfil på en ny plats",
	"action.export_over": "Spara Modell",
	"action.export_over.desc": "Sparar modellen, texturerna och animationerna genom att skriva över filerna",
	"action.add_locator": "Lägg till Lokaliseringsobjekt",
	"action.add_locator.desc": "Adds a new locator to control positions of particles, leashes etc",
	"action.uv_turn_mapping": "Turn Mapping",
	"action.uv_turn_mapping.desc": "Turn the UV mapping around 90 degrees",
	"action.remove_blank_faces": "Ta bort tomma ytor",
	"action.remove_blank_faces.desc": "Deletes all untextured faces of the selection",
	"web.download_app": "Ladda ner app",
	"uv_editor.turned": "Turned Mapping",
	"display.reference.crossbow": "Laddat armborst",
	"dialog.settings.search_results": "Sökningsresultat",
	"settings.animation_snap": "Animation Snap",
	"settings.animation_snap.desc": "Default snap interval for keyframes in the animation timeline in steps per second. This can also be changed per animation. The default value is 24.",
	"action.import_optifine_part": "Importera OptiFine Del",
	"action.import_optifine_part.desc": "Importera en del av en entitetmodell för OptiFine",
	"data.locator": "Lokaliseringsobjekt",
	"mode.start.no_recents": "Inga nyligen öppnade modeller",
	"panel.element": "Element",
	"panel.element.position": "Position",
	"panel.element.size": "Storlek",
	"panel.element.origin": "Vridpunkt",
	"panel.element.rotation": "Rotation",
	"message.canvas_limit_error.title": "Canvas Limit Error",
	"message.canvas_limit_error.message": "The action could not be performed correctly because the format limits the canvas to 48 units. Shift the pivot point to prevent this.",
	"data.effect": "Effekt",
	"generic.name": "Namn",
	"settings.recent_projects": "Recent Model Cap",
	"settings.recent_projects.desc": "Maximum number of recent models to remember",
	"settings.volume": "Volym",
	"settings.volume.desc": "Volume control for sound effects in animations",
	"action.clear_timeline": "Rensa Tidslinje",
	"action.clear_timeline.desc": "Clear all unselected bones from the timeline",
	"action.select_effect_animator": "Animera Effekter",
	"action.select_effect_animator.desc": "Öppnar tidslinjen för att lägga till ljud- och partikeleffekter",
	"action.timeline_focus": "Filtrera Kanaler",
	"action.timeline_focus.desc": "Välj de animationskanaler som ska visas i tidslinjen",
	"timeline.particle": "Partikel",
	"timeline.sound": "Ljud",
	"timeline.effects": "Effekter",
	"data.format": "Format",
	"format.optifine_part": "OptiFine Del",
	"format.optifine_part.desc": "JPM-del för OptiFine entitetmodeller",
	"action.reverse_keyframes": "Vänd om nyckelbilder",
	"action.reverse_keyframes.desc": "Vänd ordningen på de valda nyckelbilderna",
	"generic.help": "Hjälp",
	"message.removed_faces": "Tog bort %0 ytor",
	"dialog.sketchfab_uploader.draft": "Utkast",
	"action.slider_pos": "Position %0",
	"action.slider_pos.desc": "Flytta element på %0 axeln",
	"action.slider_size": "Storlek %0",
	"action.slider_size.desc": "Resize elements on the %0 axis",
	"action.slider_rotation": "Rotation %0",
	"action.slider_rotation.desc": "Rotera element på %0 axeln",
	"action.slider_origin": "Vrid %0",
	"action.slider_origin.desc": "Flytta vridningen på %0-axeln",
	"action.rotate_cw": "Rotera %0 +90",
	"action.rotate_cw.desc": "Rotate the selected elements 90° on the %0 axis",
	"action.rotate_ccw": "Rotera %0 -90",
	"action.rotate_ccw.desc": "Rotate the selected elements -90° on the %0 axis",
	"action.flip": "Flippa %0",
	"action.flip.desc": "Flip the selected elements on the %0 axis",
	"action.center": "Centrera %0",
	"action.center.desc": "Center the selected elements on the %0 axis",
	"action.bring_up_all_animations": "Bring Up All Animators",
	"panel.bone": "Ben",
	"data.color": "Färg",
	"generic.export": "Export",
	"generic.none": "Ingen",
	"status_bar.recording": "Spelar in timelapse",
	"message.add_to_palette": "Tillagd i paletten",
	"message.size_modifiers": "Håll ned Ctrl eller Shift för att transformera i mindre steg.",
	"message.timelapse_start": "Timelapse har startats",
	"message.timelapse_stop": "Timelapse har stoppats",
	"message.import_palette.replace_palette": "Byt ut den gamla paletten",
	"message.import_palette.threshold": "Merge Threshold",
	"dialog.timelapse.interval": "Intervall (Sekunder)",
	"dialog.timelapse.source": "Källa",
	"dialog.timelapse.source.interface": "Gränssnitt",
	"dialog.timelapse.source.locked": "Låst vinkel",
	"dialog.timelapse.destination": "Målmapp",
	"layout.color.checkerboard": "Schackbräde",
	"layout.color.checkerboard.desc": "Background of canvas and UV editor",
	"layout.font.code": "Kodfont",
	"layout.css": "Speciell CSS",
	"settings.category.paint": "Färg",
	"settings.deactivate_size_limit": "Inaktivera storleksgräns",
	"settings.deactivate_size_limit.desc": "Inaktivera storleksgränsen för specifika modellformat. VARNING: Detta kan skapa ogiltiga modeller.",
	"settings.brush_opacity_modifier": "Penselopacitetsmodifierare",
	"settings.brush_opacity_modifier.desc": "Ändra penselns opacitet när du använder en stylus",
	"settings.brush_size_modifier": "Penselstorleksmodifierare",
	"settings.brush_size_modifier.desc": "Ändra penselstorleken när du använder en stylus",
	"settings.brush_modifier.pressure": "Tryck",
	"settings.brush_modifier.tilt": "Luta",
	"category.color": "Färg",
	"action.import_theme": "Importera Tema",
	"action.export_theme": "Exportera Tema",
	"action.export_theme.desc": "Skapa en temafil baserat på de aktuella inställningarna",
	"action.slider_color_h": "Nyans",
	"action.slider_color_s": "Mättnad",
	"action.slider_color_v": "Värde",
	"action.add_to_palette": "Lägg till i paletten",
	"action.add_to_palette.desc": "Lägg till den valda färgen i färgpaletten",
	"action.import_palette": "Importera Palett",
	"action.import_palette.desc": "Importera en .bbpalette fil",
	"action.export_palette": "Exportera Palett",
	"action.export_palette.desc": "Exportera palett som en .GPL-fil",
	"action.generate_palette": "Generera palett...",
	"action.generate_palette.desc": "Generera palett från en textur",
	"action.sort_palette": "Sortera Palett",
	"action.sort_palette.desc": "Sortera alla färger på paletten efter färg och ljusstyrka",
	"action.timelapse": "Timelaps...",
	"action.timelapse.desc": "Spela in en timelapse av din modellerings process",
	"action.add_keyframe": "Lägg till en nyckelbild",
	"action.add_keyframe.desc": "Add a keyframe to the selected animator",
	"action.bring_up_all_animations.desc": "Brings all modified animators into the timeline",
	"timeline.timeline": "Instruktioner",
	"menu.palette.load.default": "Standard",
	"generic.import": "Importera",
	"settings.brush_modifier.none": "Ingen",
	"action.export_entity": "Exportera Bedrock entitet",
	"action.export_entity.desc": "Export the model as an entity model for Minecraft Bedrock Edition",
	"settings.highlight_cubes": "Framhäv element",
	"settings.highlight_cubes.desc": "Framhäv element när du håller muspekaren över dem eller väljer dem",
	"action.add_marker": "Set Marker",
	"action.add_marker.desc": "Set a timeline marker",
	"timeline.pre_effect_script": "Skript",
	"format.skin": "Minecraft Skin",
	"format.skin.desc": "Redigera spelar- och entitetutseenden",
	"message.sketchfab.setup_guide": "Want to learn how to set up models in Sketchfab? Read %0",
	"dialog.skin.title": "Skapa Minecraft utseende",
	"dialog.skin.model": "Modell",
	"action.toggle_skin_layer": "Växla skinlager",
	"action.toggle_skin_layer.desc": "Växla hatt- och klätlager för skinmodellen",
	"action.gui_light": "GUI Light",
	"action.gui_light.desc": "Select the way the item is lit in the inventory",
	"action.gui_light.side": "Side Light",
	"action.gui_light.front": "Front Light",
	"action.move_keyframe_back": "Move Keyframes Back",
	"action.move_keyframe_forth": "Move Keyframes Forth",
	"menu.help": "Hjälp",
	"menu.help.discord": "Discord-server",
	"menu.help.report_issue": "Rapportera ett problem",
	"menu.help.plugin_documentation": "Plugin API Documentation",
	"menu.help.search_action": "Search and Run Action",
	"menu.help.donate": "Donera",
	"menu.help.about": "Om...",
	"menu.preview.background.clipboard": "Load from Clipboard",
	"dialog.ignore": "Ignorera",
	"generic.unset": "Unset",
	"message.invalid_builtin_parent.title": "Invalid Built-in Parent",
	"message.invalid_builtin_parent.message": "The link to the invalid parent model '%0' was removed in order to export a valid model.",
	"dialog.resize_texture.fill": "Fyll med",
	"dialog.resize_texture.fill.transparent": "Transparent",
	"dialog.resize_texture.fill.color": "Färg",
	"dialog.resize_texture.fill.repeat": "Upprepa",
	"dialog.scale.element_pivot": "Element Pivot",
	"dialog.scale.selection_center": "Selection Center",
	"dialog.create_gif.length_mode": "Length Mode",
	"dialog.create_gif.length_mode.seconds": "Sekunder",
	"dialog.create_gif.length_mode.frames": "Bilder",
	"dialog.create_gif.length_mode.animation": "Animation Length",
	"dialog.create_gif.length_mode.turntable": "Turntable Rotation",
	"dialog.save_angle.projection": "Projektering",
	"dialog.save_angle.projection.perspective": "Perspektiv",
	"dialog.save_angle.projection.orthographic": "Ortografisk",
	"dialog.sketchfab_uploader.animations": "Animationer",
	"dialog.settings.theme": "Tema",
	"settings.category.interface": "Gränssnitt",
	"settings.preview_checkerboard": "Preview Checkerboard",
	"settings.preview_checkerboard.desc": "Toggle the checkerboard background behind the preview",
	"settings.uv_checkerboard": "UV Editor Checkerboard",
	"settings.uv_checkerboard.desc": "Toggle the checkerboard background behind the UV editor",
	"category.paint": "Måla",
	"action.fill_mode.color_connected": "Sammanhängande färger",
	"action.draw_shape_type": "Formtyp",
	"action.draw_shape_type.rectangle": "Rektangel",
	"action.draw_shape_type.rectangle_h": "Rektangel (ihålig)",
	"action.draw_shape_type.ellipse": "Ellips",
	"action.draw_shape_type.ellipse_h": "Ellipse (ihålig)",
	"action.draw_shape_type.line": "Linje",
	"action.mirror_painting": "Spegla målning",
	"action.mirror_painting.description": "Spegla dina penseldrag till andra sidan av modellen",
	"action.lock_alpha": "Lås alfakanal",
	"action.lock_alpha.description": "Lock the transparency of all pixels",
	"action.draw_shape_tool": "Måla form",
	"action.draw_shape_tool.desc": "Verktyg för att rita enkla former på texturer",
	"action.export_gltf": "Exportera glTF-modell",
	"action.export_gltf.desc": "Export model and animations as glTF file for sharing and rendering",
	"action.transform_space": "Transform Space",
	"action.transform_space.desc": "Default transform space for elements and bones",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Lokal",
	"action.toggle_camera_projection": "Toggle Camera Projection",
	"action.toggle_camera_projection.desc": "Toggle the camera projection between perspective and orthographic",
	"action.load_camera_angle": "Kameravinkel: %0",
	"action.load_camera_angle.desc": "Ladda kameravinkeln '%0'",
	"action.slider_face_tint": "Tint Index",
	"action.slider_face_tint.desc": "Set the tint index of the current face. -1 means unset.",
	"menu.help.quickstart": "Snabbstartsguide",
	"menu.help.developer": "Utvecklare",
	"menu.help.developer.dev_tools": "Öppna utvecklarverktyg",
	"menu.help.developer.reset_storage": "Fabriksåterställning",
	"menu.help.developer.reset_storage.confirm": "Är du säker på att du vill återställa Blockbench till fabriksinställningarna? Detta kommer att ta bort alla inställningar, kortkommandon och tilläggsprogram.",
	"menu.help.developer.cache_reload": "Ladda om cache",
	"menu.preview.orthographic": "Ortografisk",
	"menu.preview.save_angle": "Spara Vinkel...",
	"menu.preview.angle": "Vinklar",
	"menu.preview.angle.initial": "Ursprunglig vinkel",
	"menu.preview.maximize": "Maximera",
	"uv_editor.copy_selection": "Kopiera Urval",
	"uv_editor.paste_selection": "Klistra in Urval",
	"uv_editor.copy_paste_tool.place": "Placera",
	"uv_editor.copy_paste_tool.mirror_x": "Spegla X",
	"uv_editor.copy_paste_tool.mirror_y": "Spegla Y",
	"uv_editor.copy_paste_tool.rotate": "Rotera 90 Grader",
	"dialog.project.modded_entity_version": "Exportera Version",
	"dialog.save_angle.position": "Kameraposition",
	"dialog.save_angle.target": "Brännpunkt",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Window Frame",
	"layout.color.frame.desc": "Border and title bar of the window",
	"settings.large_grid_size": "Block-rutnätsstorlek",
	"settings.large_grid_size.desc": "Storlek på block-rutnätet",
	"action.load_plugin_from_url": "Load Plugin from URL",
	"action.load_plugin_from_url.desc": "Load a plugin from a server by specifying the URL",
	"action.cube_counter.desc": "Displays the current number of elements and other statistics",
	"action.unlock_everything": "Lås up alla",
	"action.unlock_everything.desc": "Unlock all groups and elements in the outliner.",
	"action.load_palette": "Ladda Palett",
	"action.load_palette.desc": "Load one of the built-in or saved palette presets",
	"action.toggle_locked": "Toggle Lock",
	"action.toggle_locked.desc": "Toggle whether the selected elements are locked",
	"action.apply_display_preset": "Tillämpa förinställning",
	"action.apply_display_preset.desc": "Tillämpa en standard- eller anpassad skärminställning",
	"action.apply_display_preset.here": "Tillämpa på denna platsen",
	"action.apply_display_preset.everywhere": "Tillämpa på alla platser",
	"action.resolve_keyframe_expressions": "Resolve Keyframe",
	"action.resolve_keyframe_expressions.desc": "Resolves the math expressions of the selected keyframes",
	"action.fold_all_animations": "Fold All Animators",
	"menu.palette.load.empty": "Tom",
	"switches.lock": "Lås",
	"settings.render_sides": "Render Sides",
	"settings.render_sides.desc": "Select which side of a face is rendered",
	"settings.render_sides.auto": "Auto",
	"settings.render_sides.front": "Utsida",
	"settings.render_sides.double": "Insida och Utsida",
	"generic.enable": "Aktivera",
	"generic.disable": "Inaktivera",
	"generic.redacted": "Redacted",
	"dialog.select_texture.import_all": "Importera Alla",
	"dialog.skin.layer_template": "Lagertextur",
	"about.version.up_to_date": "Aktuell",
	"about.version.update_available": "Version %0 är tillgänglig",
	"settings.category.application": "Application",
	"settings.streamer_mode": "Streamerläge",
	"settings.streamer_mode.desc": "Hides sensitive information like recent models",
	"settings.automatic_updates": "Automatiska uppdateringar",
	"settings.automatic_updates.desc": "Ladda ner nya versioner automatiskt och håll Blockbench uppdaterat",
	"action.rotation_space": "Rotation Space",
	"action.focus_on_selection": "Center View on Selection",
	"action.focus_on_selection.desc": "Align the camera to face the center of the current selection",
	"action.jump_to_timeline_start": "Hoppa till animationsstart",
	"action.jump_to_timeline_end": "Hoppa till animationsslut",
	"menu.help.updating": "Uppdaterar (%0%)",
	"menu.help.update_failed": "Uppdateringen misslyckades",
	"menu.animation.loop.once": "Spela en gång",
	"menu.animation.loop.hold": "Hold On Last Frame",
	"menu.animation.loop.loop": "Loop",
	"interface.streamer_mode_on": "Streamerläge aktiverat",
	"generic.reset": "Återställ",
	"generic.restore": "Återställning",
	"keys.mousewheel": "Mushjul",
	"message.delete_animation.title": "Radera Animation",
	"message.delete_animation.message": "The animation was removed from Blockbench. Do you also want to delete the animation from the file that is was saved in?",
	"message.no_animation_to_import": "Inga animationer att importera",
	"dialog.material_instances.title": "Material Instances",
	"dialog.animation_import.title": "Select Animations to Import",
	"dialog.create_texture.padding": "Padding",
	"settings.fov": "FOV",
	"settings.fov.desc": "Camera Field of View. Default is 45",
	"settings.minify_bbmodel": "Minified Project Files",
	"settings.minify_bbmodel.desc": "Write .bbmodel files minified into one line",
	"action.edit_material_instances": "Edit Material Instances",
	"action.edit_material_instances.desc": "Edit material instance names for bedrock block geometries",
	"action.save_all_animations": "Save All Animations",
	"action.save_all_animations.desc": "Save all currently loaded animations",
	"action.keyframe_interpolation": "Interpolation",
	"action.keyframe_interpolation.desc": "Select the keyframe interpolation mode",
	"action.keyframe_interpolation.linear": "Linjär",
	"action.keyframe_interpolation.catmullrom": "Slät",
	"action.timeline_focus.hide_empty": "Hide empty channels",
	"menu.file.preferences": "Preferenser",
	"menu.animation.blend_weight": "Blend Weight",
	"menu.animation.save": "Spara",
	"menu.animation.properties": "Egenskaper...",
	"menu.animation.file": "Fil",
	"menu.animation.snapping": "Snappning",
	"menu.animation.open_location": "Visa i filutforskaren",
	"panel.keyframe.add_data_point": "Add Keyframe Data Point",
	"panel.keyframe.remove_data_point": "Remove Data Point",
	"panel.keyframe.pre": "Före",
	"panel.keyframe.post": "Efter",
	"generic.all": "Alla",
	"message.small_face_dimensions.title": "Incompatible Face Dimensions",
	"message.small_face_dimensions.message": "The selection contains faces that are smaller than 1 unit in one direction. The Box UV mapping system considers any faces below that threshold as 0 pixels wide. The texture on those faces therefore may not work correctly.",
	"message.small_face_dimensions.face_uv": "The current format supports per-face UV maps which can handle small face dimensions. Right click the affected cubes and change \"UV Mode\" to \"Per-face UV\".",
	"dialog.plugins.outdated_client": "Tilläggsprogrammet kräver en nyare version av Blockbench",
	"dialog.plugins.outdated_plugin": "Tilläggsprogrammet är utdaterat och fungerar inte med den här versionen av Blockbench",
	"settings.motion_trails": "Motion Trails",
	"settings.motion_trails.desc": "Show motion trails in the animation editor",
	"settings.antialiasing": "Kantutjämning",
	"settings.antialiasing.desc": "Aktivera kantutjämning i förhandsgranskningen",
	"action.timeline_frame_back": "Hoppa tillbaka 1 bild",
	"action.timeline_frame_forth": "Hoppa fram 1 bild",
	"panel.bone.ik": "Inverse Kinematics (Experimental)",
	"settings.particle_tick_rate": "Particle Tick Rate",
	"settings.particle_tick_rate.desc": "Tick rate for particle effects in ticks per second. Default is 30",
	"action.lock_motion_trail": "Lock Motion Trail",
	"action.lock_motion_trail.desc": "Lock the motion trail to the currently selected group",
	"menu.animation_file.unload": "Ladda upp fil",
	"data.null_object": "Null Objekt",
	"status_bar.toggle_sidebar": "Toggle Sidebar",
	"message.load_plugin_failed.title": "Failed to load plugin",
	"message.load_plugin_failed.message": "Ensure that the base file name of the plugin matches the plugin ID `%0`, as specified in Plugin.register().",
	"dialog.project.uv_mode": "UV Mode",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "Per-face UV",
	"dialog.project.texture_size": "Texture Size",
	"dialog.animation_export.title": "Select Animations to Export",
	"dialog.create_texture.rearrange_uv": "Rearrange UV",
	"layout.color.subtle_text": "Subtle Text",
	"layout.color.subtle_text.desc": "Secondary text color with less contrast",
	"settings.interface_scale": "Interface Scale",
	"settings.interface_scale.desc": "Skala för hela Blockbench-gränssnittet",
	"settings.background_rendering": "Background Rendering",
	"settings.background_rendering.desc": "Update the preview while the window is not focused",
	"settings.ctrl_shift_size": "Control + Shift Resolution",
	"settings.ctrl_shift_size.desc": "Resolution of the grid while holding control and shift",
	"settings.hardware_acceleration": "Hardware Acceleration",
	"settings.hardware_acceleration.desc": "Lägg ut renderingsuppgifter till grafikkortet",
	"action.explode_skin_model": "Explode Skin Model",
	"action.explode_skin_model.desc": "Toggles an explosion view that allows you to edit covered faces",
	"action.export_minecraft_skin": "Exportera Minecraft Skin",
	"action.export_minecraft_skin.desc": "Exportera Minecraft-skinnet som en PNG textur",
	"action.add_null_object": "Add Null Object",
	"action.add_null_object.desc": "Adds a new null object",
	"action.animated_texture_frame": "Animated Texture Frame",
	"action.animated_texture_frame.desc": "Set the current frame of the animated texture",
	"action.export_animation_file": "Export Animations...",
	"action.export_animation_file.desc": "Export a selection of animations into a new file",
	"action.timeline_graph_editor": "Toggle Graph Editor",
	"action.timeline_graph_editor.desc": "Toggle the timeline between graph editor view and keyframe view",
	"menu.file.recent.clear": "Rensa senaste filer",
	"switches.shade": "Shade",
	"generic.share": "Dela",
	"dates.minute": "%0 minut",
	"dates.minutes": "%0 minuter",
	"dates.hour": "%0 timme",
	"dates.hours": "%0 timmar",
	"dates.day": "%0 dag",
	"dates.days": "%0 dagar",
	"dates.week": "%0 vecka",
	"dates.weeks": "%0 veckor",
	"dates.year": "%0 år",
	"dates.years": "%0 år",
	"message.installed_plugin": "Tilläggsprogrammet %0 har installerats",
	"message.installed_plugin_fail": "Misslyckades att installera tilläggsprogrammet %0",
	"dialog.share_model.title": "Dela modell",
	"dialog.share_model.expire_time": "Expire Time",
	"dialog.share_model.failed": "Failed to upload model",
	"action.import_java_block_model": "Add Java Block/Item Model",
	"action.import_java_block_model.desc": "Add a Minecraft Java block/item model from a json file to the current model",
	"action.share_model": "Dela...",
	"action.share_model.desc": "Skapa en kort länk för att dela din modell",
	"action.import_project": "Importera projekt",
	"action.import_project.desc": "Import another project from a .bbmodel file into the current project",
	"dialog.toolbar_edit.hidden_tools": "Some tools might be hidden because they are not available in the current mode, format, or situation.",
	"settings.camera_near_plane": "Camera Near Plane",
	"settings.camera_near_plane.desc": "The minimum distance from the camera where objects render. Higher values decrease Z-fighting. Default is 1.",
	"mode.start.keymap_preference.desc": "Om du är Blockbench nybörjare och kommer från ett annat 3D-program kan du välja en tangentbordsmappning för att göra övergången enklare. Du kan ändra tangentbordsmappningen eller individuella tangentbindningar senare i inställningarna.",
	"message.load_keymap": "Are you sure you want to load this keymap? This will overwrite your current keybindings.",
	"message.keymap_loaded": "Keymap loaded",
	"dialog.convert_project.current_format": "Nuvarande format",
	"dialog.create_texture.rearrange_uv.desc": "Create a new UV arrangement to give every face its own spot on the texture",
	"dialog.create_texture.power.desc": "Lock the automatic texture size to a power-of-2, such as 64 or 128. This is required by some renderers",
	"dialog.create_texture.double_use.desc": "If two elements already have the same UV space assigned, keep it that way in the new map",
	"dialog.create_texture.padding.desc": "Add a small padding between the individual parts of the template",
	"dialog.create_texture.resolution.desc": "The height and width of the texture",
	"dialog.create_gif.color": "Background Color",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variant",
	"dialog.flip_animation.info": "Opposite bones are identified by the keywords 'left' and 'right' within their name.",
	"dialog.export_private_settings.title": "Private Settings",
	"dialog.export_private_settings.message": "Your file contains the following private informations: **%0**. Leave these values out if you plan to share the file with someone else.",
	"dialog.export_private_settings.keep": "Keep",
	"settings.timecode_frame_number": "Display Timecodes as Frame Numbers",
	"settings.timecode_frame_number.desc": "Display fraction timecodes in the timeline as frame number instead of centisecond",
	"settings.animation_sample_rate": "Animation Sample Rate",
	"settings.animation_sample_rate.desc": "Sample rate in samples per second for curves that the respective format does not support natively",
	"keybind.preview_zoom": "Drag-to-Zoom View",
	"action.gradient_tool": "Gradient Tool",
	"action.gradient_tool.desc": "Create a color gradient on your texture",
	"action.import_settings": "Import Settings",
	"action.import_settings.desc": "Import a .bbsettings file",
	"action.export_settings": "Export Settings",
	"action.export_settings.desc": "Exportera Blockbench-inställningarna som en .bbsettings-fil",
	"action.load_keymap": "Load Keymap",
	"action.load_keymap.default": "Default (Trackpad/Mouse)",
	"action.load_keymap.mouse": "Default (Mouse)",
	"action.load_keymap.default.desc": "Default Blockbench keybindings, with viewport navigation controls optimized for use on laptop trackpads",
	"action.load_keymap.mouse.desc": "Default Blockbench keybindings, with viewport navigation bound to the middle mouse button",
	"action.load_keymap.blender.desc": "Keymap for users who are familiar with the controls of Blender",
	"action.load_keymap.cinema4d.desc": "Keymap for users who are familiar with the controls of Cinema 4D",
	"action.load_keymap.maya.desc": "Keymap for users who are familiar with the controls of Autodesk Maya",
	"action.import_keymap": "Importera tangentbordsmapp",
	"action.import_keymap.desc": "Import keybindings a .bbkeymap file",
	"action.export_keymap": "Exportera tangentbordsmapp",
	"action.export_keymap.desc": "Export the current keybindings as a .bbkeymap file",
	"action.edit_history": "Ändra historik...",
	"action.edit_history.desc": "View the editing history and undo or redo steps",
	"action.group_elements": "Gruppera element",
	"action.group_elements.desc": "Wrap selected elements into a new group",
	"action.unfold_groups": "Unfold Groups",
	"action.unfold_groups.desc": "Unfold all group or nested elementss in the outliner",
	"action.edit_bedrock_binding": "Edit Binding...",
	"action.edit_bedrock_binding.desc": "Change which bone the geometry is bound to",
	"action.pick_screen_color": "Pick Screen Color",
	"action.pick_screen_color.desc": "Pick a color from somewhere on your screen",
	"action.view_mode": "View Mode",
	"action.view_mode.desc": "Change the model view mode",
	"action.view_mode.textured": "Textured",
	"action.view_mode.solid": "Solid",
	"action.view_mode.wireframe": "Wireframe",
	"action.toggle_sidebars": "Toggle Sidebars",
	"action.toggle_sidebars.desc": "Enable or disable the sidebars",
	"action.set_animation_end": "Set Animation End",
	"action.set_animation_end.desc": "Set the end of the selected animation to the current timeline time",
	"action.flip_animation": "Flip Animation",
	"action.flip_animation.desc": "Flips part of an animation by copying selected keyframes to the other side of the model",
	"action.graph_editor_zero_line": "Include Zero Line",
	"action.graph_editor_zero_line.desc": "Whether the graph editor always includes the zero line in the view",
	"menu.texture.render_mode": "Render Mode",
	"menu.texture.render_mode.emissive": "Emissive",
	"menu.texture.render_mode.layered": "Layered",
	"menu.preview.angle.edit": "Ändra vinkel...",
	"menu.animation.start_delay": "Startfördröjning",
	"menu.animation.loop_delay": "Loopfördröjning",
	"menu.animation.flip_keyframes": "Vänd nyckelbilder",
	"menu.mobile_keyboard.disable_all": "Disable All",
	"panel.keyframe.toggle_uniform_scale": "Toggle Uniform Scale",
	"camera_angle.common_isometric_right": "Isometric Right (2:1)",
	"camera_angle.common_isometric_left": "Isometric Left (2:1)",
	"camera_angle.true_isometric_right": "True Isometric Right (30°)",
	"camera_angle.true_isometric_left": "True Isometric Left (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Update to Pre-releases",
	"settings.update_to_prereleases.desc": "Automatically update to Blockbench beta versions to test new features. Pre-release versions can be unstable, don't enable this option if you rely on Blockbench for work or other important projects.",
	"data.separator.spacer": "Spacer",
	"data.separator.linebreak": "Line Break",
	"data.setting": "Setting",
	"generic.select_all": "Välj alla",
	"generic.select_none": "Välj ingen",
	"projects.new_tab": "Ny flik",
	"projects.close_tab": "Stäng flik",
	"message.invalid_format.title": "Invalid Format",
	"message.invalid_format.message": "This model was made in the format '%0', which is not available in your Blockbench installation. You most likely need a specific plugin to open it correctly.",
	"message.invalid_link": "Invalid or Expired Model Link",
	"message.default_textures.current": "Current path",
	"message.update_after_restart": "The update will be installed after the next restart",
	"message.copy_paste_tool_viewport": "This tool can only be used in the 2D editor",
	"dialog.project.shadow_size": "Shadow Size",
	"dialog.find_replace.target": "Target",
	"dialog.find_replace.target.element_names": "Element Names",
	"dialog.find_replace.target.group_names": "Group Names",
	"dialog.find_replace.target.animation_names": "Animation Names",
	"dialog.find_replace.target.keyframe_values": "Nyckelbildsvärden",
	"dialog.find_replace.find": "Hitta",
	"dialog.find_replace.replace": "Ersätt",
	"dialog.find_replace.regex": "Reguljärt uttryck",
	"dialog.add_primitive.shape": "Form",
	"dialog.add_primitive.shape.circle": "Cirkel",
	"dialog.add_primitive.shape.tube": "Tub",
	"dialog.add_primitive.shape.cone": "Kon",
	"dialog.add_primitive.shape.cylinder": "Cylinder",
	"dialog.add_primitive.shape.sphere": "Sfär",
	"dialog.add_primitive.shape.torus": "Torus",
	"dialog.add_primitive.shape.cube": "Kuboid",
	"dialog.add_primitive.shape.pyramid": "Pyramid",
	"dialog.add_primitive.diameter": "Diameter",
	"dialog.add_primitive.height": "Höjd",
	"dialog.add_primitive.sides": "Sidor",
	"dialog.add_primitive.minor_diameter": "Tjocklek",
	"dialog.add_primitive.minor_sides": "Spegla sidor",
	"dialog.create_texture.combine_polys": "Kombinera öar",
	"dialog.create_texture.combine_polys.desc": "Kombinera polygoner till sammankopplade UV-öar",
	"dialog.model_stats.meshes": "Polygonnät",
	"dialog.export_private_settings.omit": "Utelämna",
	"layout.select": "Välj",
	"layout.options": "Alternativ",
	"layout.color": "Color Scheme",
	"layout.documentation": "Dokumentation",
	"layout.color.bright_ui_text": "Bright UI Text",
	"layout.color.bright_ui_text.desc": "Text on bright backgrounds",
	"layout.name": "Namn",
	"layout.author": "Författare",
	"settings.dialog.desc": "Show the \"%0\" dialog",
	"settings.export_empty_groups": "Exportera tomma grupper",
	"settings.export_empty_groups.desc": "Include groups without content in exported files",
	"category.separators": "Separators",
	"keybind.preview_area_select": "Area Select",
	"action.color_erase_mode": "Erase Mode",
	"action.color_erase_mode.desc": "With erase mode enabled, tools like Fill and Rectangle subtract colors rather than adding them",
	"action.open_from_link": "Öppna modell från länk...",
	"action.open_from_link.desc": "Öppna en modell från en blckbn.ch URL",
	"action.import_obj": "Importera OBJ-modell",
	"action.import_obj.desc": "Importera objekt från en OBJ-modell som polygonnät",
	"action.add_plugin": "Install Plugin",
	"action.add_plugin.desc": "Install a plugin through Action Control",
	"action.remove_plugin": "Uninstall Plugin",
	"action.remove_plugin.desc": "Uninstall a plugin through Action Control",
	"action.add_mesh": "Lägg till polygonnät",
	"action.add_mesh.desc": "Lägger till ett nytt polygonnät",
	"action.add_texture_mesh": "Add Texture Mesh",
	"action.add_texture_mesh.desc": "Adds a new Texture Mesh",
	"action.find_replace": "Find/Replace...",
	"action.find_replace.desc": "Find and replace parts of names",
	"action.hide_everything_except_selection": "Hide Everything Except Selection",
	"action.hide_everything_except_selection.desc": "Toggle visibility on all elements except the ones that are selected",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Selection Mode",
	"action.selection_mode.desc": "Change how elements can be selected in the viewport",
	"action.selection_mode.object": "Object",
	"action.selection_mode.face": "Yta",
	"action.selection_mode.vertex": "Nod",
	"action.create_face": "Skapa yta eller kant",
	"action.create_face.desc": "Skapar en ny sida eller kant mellan de markerade noderna",
	"action.convert_to_mesh": "Konvertera till ett polygonnät",
	"action.convert_to_mesh.desc": "Convert the selected elements into meshes",
	"action.invert_face": "Invertera yta",
	"action.invert_face.desc": "Invert the selected faces to make them face the opposite direction",
	"action.extrude_mesh_selection": "Extrude Selection",
	"action.extrude_mesh_selection.desc": "Extrude the selected parts of the mesh",
	"action.loop_cut": "Loop Cut",
	"action.loop_cut.desc": "Split the mesh in a loop across the selected edge",
	"action.merge_meshes": "Merge Meshes",
	"action.merge_meshes.desc": "Merge multiple meshes into one",
	"action.keyframe_uniform": "Uniform Scaling",
	"action.keyframe_uniform.desc": "Enable uniform scaling on the selected keyframes",
	"menu.locator.ignore_inherited_scale": "Ignore Inherited Scale",
	"menu.texture.elements": "Applicera på element",
	"uv_editor.transparent_face": "Genomskinlig yta",
	"display.pose_angle": "Pose Angle (For Preview Only)",
	"data.mesh": "Polygonnät",
	"dialog.create_texture.type": "Type",
	"dialog.create_texture.type.blank": "Blank",
	"dialog.create_texture.type.template": "Texture Template",
	"dialog.create_texture.type.color_map": "Solid Color Template",
	"dialog.sketchfab_uploader.suggested_tags": "Suggested Tags",
	"dialog.sketchfab_uploader.category": "Kategori",
	"dialog.sketchfab_uploader.category2": "Kategori 2",
	"layout.restore_backup": "Your customized theme \"%0\" was overwritten. Click here to restore it.",
	"layout.borders": "Kanter",
	"action.fill_mode.element": "Element",
	"action.inset_mesh_selection": "Inset Selection",
	"action.inset_mesh_selection.desc": "Inset the selected parts of the mesh",
	"action.dissolve_edges": "Dissolve Edges",
	"action.dissolve_edges.desc": "Dissolve selected edges in a mesh and merge the faces they divide",
	"action.split_mesh": "Dela polygonnät",
	"action.split_mesh.desc": "Split the selected faces of the mesh into a new mesh",
	"action.merge_vertices": "Sammanfoga hörn",
	"action.merge_vertices.desc": "Merge the selected vertices into the position of the first selected vertex",
	"action.view_mode.normal": "Ytorientering",
	"action.snap_uv_to_pixels": "Fäst UV till pixlar",
	"action.snap_uv_to_pixels.desc": "Snaps the selected UV vertices to the pixel grid",
	"menu.file.import.import_open_project": "Import Open Project",
	"menu.help.unlock_projects": "Unlock All Projects",
	"status_bar.selection.faces": "%0 ytor",
	"status_bar.selection.vertices": "%0 hörn",
	"message.merged_vertices": "Hittade och sammanfogade %0 noder på %1 platser",
	"settings.vertex_merge_distance": "Nodsammanfogningsavstånd",
	"settings.vertex_merge_distance.desc": "Distance within which vertices are merged using merging by distance",
	"settings.show_only_selected_uv": "Show Only Selected UV",
	"settings.show_only_selected_uv.desc": "Only display the selected UV faces in the UV editor by default",
	"action.merge_vertices.merge_all": "Sammanfoga alla",
	"action.merge_vertices.merge_all_in_center": "Sammanfoga alla i mitten",
	"action.merge_vertices.merge_by_distance": "Sammanfoga efter avstånd",
	"action.merge_vertices.merge_by_distance_in_center": "Sammanfoga efter avstånd i centrum",
	"action.uv_rotate_left": "Rotate UV Left",
	"action.uv_rotate_left.desc": "Rotate the selected UV faces counter-clockwise",
	"action.uv_rotate_right": "Rotate UV Right",
	"action.uv_rotate_right.desc": "Rotate the selected UV faces clockwise",
	"menu.uv.display_uv": "Display UV",
	"menu.uv.display_uv.selected_faces": "Valda polygoner",
	"menu.uv.display_uv.selected_elements": "Alla polygoner",
	"menu.uv.display_uv.all_elements": "All Faces on All Elements",
	"menu.paste.face": "UV-yta",
	"menu.paste.mesh_selection": "Polygonnät",
	"menu.paste.outliner": "Element",
	"uv_editor.show_all_faces": "Visa alla ytor",
	"uv_editor.show_selected_faces": "Visa valda ytor",
	"status_bar.selection.edges": "%0 Kanter",
	"action.selection_mode.edge": "Kant",
	"message.cannot_re_import.title": "Modellen kan inte importeras igen",
	"message.cannot_re_import.message": "The exported model format cannot be imported into Blockbench again. Please make sure to save your model as a project file.",
	"generic.default": "Default",
	"units.pixels_per_meter": "%0 pixlar per meter",
	"mode.pose": "Pose",
	"modifier_actions.resize_both_sides": "Resize in both directions",
	"modifier_actions.resize_one_side": "Resize in one direction",
	"modifier_actions.draw_line": "Draw line",
	"modifier_actions.drag_without_snapping": "Drag without snapping",
	"modifier_actions.stretch_keyframes": "Stretch keyframes",
	"modifier_actions.resize_background": "Resize background",
	"modifier_actions.select_multiple": "Select multiple",
	"modifier_actions.select_range": "Select range",
	"modifier_actions.drag_to_duplicate": "Drag to duplicate",
	"modifier_actions.uniform_scaling": "Uniform Scaling",
	"modifier_actions.snap_direction": "Snap Direction",
	"message.no_valid_elements": "No valid elements selected...",
	"dialog.add_primitive.shape.plane": "Plane",
	"dialog.save_angle.rotation_mode": "Rotation Mode",
	"dialog.save_angle.rotation": "Rotation",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Auto-hide Tab Bar",
	"settings.hide_tab_bar.desc": "Hide the tab bar when only one tab is open",
	"settings.status_bar_modifier_keys": "Suggest Modifier Keys in Status Bar",
	"settings.status_bar_modifier_keys.desc": "Display context aware suggested modifier keys in the status bar",
	"settings.ground_plane": "Ground Plane",
	"settings.ground_plane.desc": "Show a floor plane below the model",
	"settings.preview_paste_behavior": "Default Viewport Paste Behavior",
	"settings.preview_paste_behavior.desc": "Select the behavior when pasting something into the viewport in Edit mode and multiple options are available",
	"settings.preview_paste_behavior.always_ask": "Always Ask",
	"action.new_window": "Nytt fönster",
	"action.new_window.desc": "Öppnar ett nytt Blockbench fönster",
	"action.export_collada": "Export Collada Model (dae)",
	"action.export_collada.desc": "Export model and animations as dae file to use it in other 3D applications",
	"action.paint_mode_uv_overlay": "UV Overlay",
	"action.paint_mode_uv_overlay.desc": "Display the UV map as an overlay in paint mode",
	"action.bake_animation_into_model": "Bake Animation Pose into Model",
	"action.bake_animation_into_model.desc": "Bake the currently displayed animation frame into the model. Only applies rotation and position, scale is ignored.",
	"action.keyframe_interpolation.step": "Steg",
	"action.set_ik_target": "Set IK Target",
	"action.set_ik_target.desc": "Select the target bone that should be moved by this null object via Inverse Kinematics",
	"menu.action_control.type.tab": "Flik",
	"menu.action_control.type.angle": "Kameravinkel",
	"menu.action_control.recent_in_streamer_mode": "Sure? Streamer Mode is enabled",
	"menu.action_control.recent_in_streamer_mode.desc": "Are you sure you want to display recent models?",
	"menu.tools": "Verktyg",
	"menu.file.recent.more": "Visa mer...",
	"menu.null_object.lock_ik_target_rotation": "Lock IK Target Rotation",
	"menu.animation_file.import_remaining": "Import Remaining from File",
	"edit.loop_cut.offset": "Offset",
	"edit.extrude_mesh_selection.extend": "Extend",
	"cube.color.pink": "Rosa",
	"cube.color.silver": "Silver",
	"dialog.plugins.offline": "No internet connection",
	"dialog.create_texture.pixel_density": "Pixel Density",
	"dialog.create_texture.pixel_density.desc": "The pixel density of the texture, in pixels per meter. The size of the texture map may differ depending on the amount and size of elements.",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "None",
	"panel.skin_pose.natural": "Natural",
	"panel.skin_pose.walking": "Walking",
	"panel.skin_pose.crouching": "Crouching",
	"panel.skin_pose.sitting": "Sitting",
	"panel.skin_pose.jumping": "Jumping",
	"panel.skin_pose.aiming": "Aiming",
	"edit.loop_cut.direction": "Direction",
	"data.texture_mesh": "Texture Mesh",
	"generic.left": "Left",
	"generic.right": "Right",
	"mode.start.quick_setup": "Quick Setup",
	"mode.start.keymap": "Keymap",
	"mode.start.quick_setup.more_themes": "More...",
	"dialog.resize_texture.animation_frames": "Animation Frames",
	"dialog.export_emission_map.title": "Export Emission Map",
	"dialog.export_emission_map.format": "Format",
	"dialog.export_emission_map.format.luminance": "Luminance",
	"dialog.export_emission_map.format.luminance_inverted": "Luminance Inverted",
	"dialog.export_emission_map.format.colors": "Colors",
	"dialog.export_emission_map.threshold": "Transparency Threshold",
	"dialog.export_emission_map.round_up": "Round Up to %0 x %1",
	"dialog.export_emission_map.flip_y": "Flip Y Axis",
	"dialog.select.type": "Element Type",
	"dialog.create_texture.max_edge_angle": "Edge Angle Threshold",
	"dialog.create_texture.max_edge_angle.desc": "The maximum angle between two faces at which they will still be combined",
	"dialog.create_texture.max_island_angle": "Island Angle Threshold",
	"dialog.create_texture.max_island_angle.desc": "The maximum angle that can be combined into the same UV island",
	"settings.mobile_panel_side": "Mobile Panel Side",
	"settings.mobile_panel_side.desc": "Select which side of the screen panels are displayed on when using Blockbench on in landscape orientation",
	"settings.obj_face_export_mode": "OBJ Face Export Mode",
	"settings.obj_face_export_mode.desc": "Choose to let the OBJ exporter convert all faces into tris or quads",
	"settings.obj_face_export_mode.both": "Standard",
	"settings.obj_face_export_mode.tris": "Konvertera till trianglar",
	"settings.obj_face_export_mode.quads": "Konvertera till rektanglar",
	"action.seam_tool": "Seam Tool",
	"action.seam_tool.desc": "Tool to define UV seams on mesh edges",
	"action.resolve_group": "Resolve Group",
	"action.resolve_group.desc": "Resolve the group while retaining its children in the same place",
	"action.move_to_group": "Move to",
	"action.move_to_group.desc": "Move the selected elements to a different outliner group or element",
	"action.select_seam": "Select UV Seam",
	"action.select_seam.desc": "Select the UV seam mode for the selected edges",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Sammanfoga",
	"action.select_seam.divide": "Dela",
	"action.adjust_brightness_contrast": "Adjust Brightness & Contrast...",
	"action.adjust_brightness_contrast.desc": "Adjust the brightness and contrast of the selected texture",
	"action.adjust_saturation_hue": "Adjust Saturation & Hue...",
	"action.adjust_saturation_hue.desc": "Adjust the saturation and hue of the selected texture",
	"action.invert_colors": "Invertera färger",
	"action.invert_colors.desc": "Invert all colors of the selected texture",
	"action.adjust_curves": "Adjust Curves...",
	"action.adjust_curves.desc": "Adjust the brightness curves of the selected texture",
	"action.flip_texture_x": "Vänd horisontellt",
	"action.flip_texture_y": "Vänd vertikalt",
	"action.resize_texture": "Resize Texture...",
	"action.view_mode.uv": "UV Preview",
	"action.append_to_template": "Append Elements to Template...",
	"action.append_to_template.desc": "Add the currently selected elements to the texture template",
	"action.move_texture_with_uv": "Move Texture with UV",
	"action.move_texture_with_uv.desc": "Move the texture of the face along when dragging UV faces",
	"action.timeline_setups": "Timeline Setups",
	"action.save_timeline_setup": "Save Timeline Setup...",
	"action.save_timeline_setup.desc": "Save a preset for the currently selected animators and channels",
	"menu.texture": "Texture",
	"menu.texture.render_mode.default": "Default",
	"menu.texture.merge_onto_texture": "Merge Onto Texture Above",
	"menu.animation.unload": "Unload",
	"panel.timeline": "Timeline",
	"action.pan_tool": "Pan Tool",
	"action.pan_tool.desc": "Tool to navigate in the viewport and the texture editor",
	"mode.start.recent.favorite": "Mark as Favorite",
	"mode.start.info": "Info",
	"mode.start.target": "Target",
	"mode.start.start": "Start",
	"mode.start.create_new": "Create New Model",
	"mode.start.format.informations": "Good to know:",
	"mode.start.format.resources": "Resources:",
	"format.free.info.meshes": "In this format, you can create low poly models using cubes and custom shaped meshes.",
	"format.free.info.limitation": "Models cannot be loaded into games that need specialized formats, such as Minecraft.",
	"format.skin.info.skin": "This format is designed to create Minecraft skins and entity textures.",
	"format.skin.info.model": "The model cannot be changed. In order to make changes to the model, first convert to a different format via **File** > **Convert Project**.",
	"format.java_block.info.rotation": "Rotations are limited to one axis per element",
	"format.java_block.info.size": "The model is limited to a size of 3 by 3 by 3 blocks. Display settings can make item models larger though",
	"format.java_block.info.animation": "This format does not support animations in vanilla Minecraft. If you are creating a mod, you can use GeckoLib to animate models. If not, the only way to animate is to switch out the model using commands or animated textures.",
	"format.bedrock.info.textures": "Each model can only have one texture",
	"format.bedrock_block": "Bedrock Block",
	"format.bedrock_block.desc": "Block model for Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "The size of individual cubes is limited to integers.",
	"format.modded_entity.info.format": "Models are written in Java code instead of dedicated data structures like all other Blockbench export formats.",
	"format.optifine_entity.info.optifine_required": "Users without OptiFine installed won't see the model.",
	"format.optifine_entity.info.pivots": "Bone pivots are locked, so it is a good idea to leave them untouched.",
	"format_category.low_poly": "Lågpolygonal",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Other",
	"format_category.loaders": "Loaders",
	"message.recover_backup.recover": "Återställ",
	"message.invalid_characters.title": "Invalid Path",
	"message.invalid_characters.message": "The path of the imported file contains invalid characters, uppercase letters, or white spaces. The supported characters are: %0",
	"dialog.share_model.thumbnail": "Miniatyrbild",
	"dialog.skin.high_res_texture": "Please note that skins with the selected resolution will not work as regular Minecraft skins. Select a lower resolution.",
	"settings.allow_display_slot_mirror": "Allow Display Slot Mirroring",
	"settings.allow_display_slot_mirror.desc": "Allow Display slots for Java item models to be mirrored. WARNING: This only works in Minecraft 1.14 or earlier or in special cases.",
	"action.switch_tabs": "Byt flik",
	"action.switch_tabs.desc": "Cycle between opened tabs. Hold shift to cycle in the opposite direction.",
	"action.unselect_all": "Unselect All",
	"action.save_palette": "Save Palette...",
	"action.save_palette.desc": "Save the current color palette inside Blockbench for later use",
	"action.keyframe_column_create": "Create Keyframe Column",
	"action.keyframe_column_create.desc": "Key all channels in the timeline at the current timecode, if they already have keyframes",
	"action.keyframe_column_select": "Select Keyframe Column",
	"action.keyframe_column_select.desc": "Select all keyframes in the timeline along a column below the playhead",
	"menu.uv": "UV",
	"menu.keyframe": "Nyckelbild",
	"menu.palette.load.update": "Uppdatera paletten",
	"menu.palette.load.update.desc": "Updates this palette with the colors of the current Blockbench palette",
	"menu.timeline_marker.set_time": "Ställ in tid...",
	"uv_editor.scale_uv": "Scale UV",
	"action.preview_scene": "Preview Scene",
	"action.preview_scene.desc": "Change the model preview scene",
	"preview_scene.minecraft_overworld": "Överjorden",
	"preview_scene.minecraft_nether": "Nethern",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Vänd Y-axeln",
	"preview_scene.studio": "Studio",
	"format.image": "Bild",
	"modifier_actions.set_copy_source": "Set Copy Source",
	"message.load_images.title": "Load Images",
	"message.load_images.edit_image": "Edit Image",
	"dialog.add_primitive.align_edges": "Align Edges",
	"dialog.flip_animation.show_in_timeline": "Show modified bones in timeline",
	"settings.default_cube_size": "Cube Size",
	"settings.default_cube_size.desc": "Set the default cube size when creating a new cube",
	"settings.uniform_keyframe": "Uniform Scale Keyframes",
	"settings.uniform_keyframe.desc": "Set scale keyframes to uniform scaling by default",
	"settings.nearest_rectangle_select": "Rectangle Selection: Nearest Edge",
	"settings.nearest_rectangle_select.desc": "Snap rectangle selections to the nearest pixel edge, like in GIMP, instead of entire pixels.",
	"settings.pick_color_opacity": "Pick Color Opacity",
	"settings.pick_color_opacity.desc": "Pick the color opacity with the Color Picker and set it as brush opacity",
	"settings.paint_with_stylus_only": "Paint with Stylus Only",
	"settings.paint_with_stylus_only.desc": "Only use the stylus for painting, reserve mouse or touch input for navigation.",
	"action.copy_brush_mode": "Copy Brush Mode",
	"action.copy_brush_mode.copy": "Copy",
	"action.copy_brush_mode.pattern": "Pattern",
	"action.copy_brush_mode.sample": "Sample",
	"action.brush_shape": "Brush Shape",
	"action.brush_shape.square": "Square",
	"action.brush_shape.circle": "Circle",
	"action.blend_mode": "Blend Mode",
	"action.blend_mode.default": "Default",
	"action.blend_mode.set_opacity": "Set Opacity",
	"action.blend_mode.color": "Color",
	"action.blend_mode.behind": "Behind",
	"action.blend_mode.multiply": "Multiply",
	"action.blend_mode.divide": "Divide",
	"action.blend_mode.add": "Add",
	"action.blend_mode.subtract": "Subtract",
	"action.blend_mode.screen": "Screen",
	"action.blend_mode.overlay": "Overlay",
	"action.blend_mode.hard_light": "Hard Light",
	"action.blend_mode.difference": "Difference",
	"action.copy_brush": "Copy Brush",
	"action.copy_brush.desc": "Brush to clone parts of your texture or draw patterns. Hold Ctrl and click to select a copy source.",
	"action.validator_window": "View Model Issues...",
	"action.validator_window.desc": "Opens the validator, which lists issues with the current model.",
	"action.cancel_gif": "Cancel GIF",
	"menu.text_edit.copy_vector": "Copy Vector",
	"menu.brush_presets.dialog": "Brush Presets...",
	"menu.brush_presets.pixel_brush": "Pixel Brush",
	"menu.brush_presets.smooth_brush": "Smooth Brush",
	"menu.texture.edit_in_blockbench": "Edit in Blockbench",
	"menu.mirror_painting.axis": "Axis",
	"menu.mirror_painting.axis.desc": "Select on which axis paint strokes will get mirrored",
	"menu.mirror_painting.global": "Global Symmetry",
	"menu.mirror_painting.global.desc": "Enabled mirror painting on the model in global space",
	"menu.mirror_painting.local": "Local Symmetry",
	"menu.mirror_painting.local.desc": "Enable mirror painting in local space for each element",
	"menu.mirror_painting.texture_frames": "Repeat on Flipbook Frames",
	"menu.mirror_painting.texture_frames.desc": "Mirror paint strokes to every frame of animated textures",
	"format.bedrock_block.info.size_limit": "Size total size of a block is limited to 30 pixels in all dimensions. The limit can be off-centered in all directions by 7 pixels from the block center.",
	"format.bedrock_block.info.textures": "Multiple textures can be applied to different cubes in Blockbench, but require additional setup in the behavior pack to work correctly in-game.",
	"format.image.desc": "Edit images in the 2D image editor",
	"generic.delete_all": "Delete All",
	"message.child_model_only.open": "Open Parent Model",
	"dialog.project.credit": "Credit",
	"dialog.convert_project.create_copy": "Create Copy",
	"dialog.texture.frame_time": "Frame Time",
	"dialog.texture.frame_time.desc": "Set for how long each frame will be visible, in ticks. Each tick is 1/20th of a second.",
	"dialog.texture.frame_interpolate": "Interpolate",
	"dialog.texture.frame_interpolate.desc": "Interpolate between animation frames by cross-fading to the next frame",
	"dialog.texture.frame_order_type": "Loop Mode",
	"dialog.texture.frame_order_type.loop": "Loop",
	"dialog.texture.frame_order_type.backwards": "Loop Backwards",
	"dialog.texture.frame_order_type.back_and_forth": "Back-and-Forth",
	"dialog.texture.frame_order_type.custom": "Custom Order",
	"dialog.texture.frame_order": "Frame Order",
	"dialog.texture.frame_order.desc": "Set a custom frame order by listing frame indices in a new order. Frame indices start at 0 with the first frame.",
	"dialog.select.mode": "Mode",
	"dialog.select.mode.new": "New Selection",
	"dialog.select.mode.add": "Add to Selected",
	"dialog.select.mode.remove": "Remove from Selected",
	"dialog.select.mode.in_selection": "Select only from Selected",
	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Predicates",
	"dialog.predicate_overrides.variants": "Variants",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Add Override",
	"dialog.predicate_overrides.add_predicate": "Add Predicate",
	"dialog.predicate_overrides.generate_overrides": "Generate Overrides",
	"dialog.predicate_overrides.confirm_delete": "Are you sure you want to delete all overrides?",
	"dialog.predicate_overrides.predicate.angle": "Compass Angle",
	"dialog.predicate_overrides.predicate.blocking": "Is Blocking",
	"dialog.predicate_overrides.predicate.broken": "Is Broken",
	"dialog.predicate_overrides.predicate.cast": "Is Cast",
	"dialog.predicate_overrides.predicate.cooldown": "Cooldown",
	"dialog.predicate_overrides.predicate.damage": "Damage",
	"dialog.predicate_overrides.predicate.damaged": "Is Damaged",
	"dialog.predicate_overrides.predicate.lefthanded": "Is Left-Handed",
	"dialog.predicate_overrides.predicate.pull": "Pull Amount",
	"dialog.predicate_overrides.predicate.pulling": "Is Pulling",
	"dialog.predicate_overrides.predicate.charged": "Is Charged",
	"dialog.predicate_overrides.predicate.firework": "Has Firework",
	"dialog.predicate_overrides.predicate.throwing": "Ready to Throw",
	"dialog.predicate_overrides.predicate.time": "Time of Day",
	"dialog.predicate_overrides.predicate.custom_model_data": "Custom Model Data",
	"dialog.predicate_overrides.predicate.level": "Light Level",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",
	"settings.model_export_scale": "Model Export Scale",
	"settings.model_export_scale.desc": "Factor by which the scale of exported glTF, DAE, and FBX models gets reduced. The default is 16, which converts 16 Blockbench units into 1 meter in the export.",
	"action.export_fbx": "Export FBX Model",
	"action.export_fbx.desc": "Export model and animations as fbx file to use it in other 3D applications and game engines",
	"action.center_lateral": "Center Lateral",
	"action.center_lateral.desc": "Center the selected elements on the X and Z axis",
	"action.adjust_opacity": "Adjust Opacity...",
	"action.adjust_opacity.desc": "Adjust the opacity of the selected texture",
	"action.rotate_texture_cw": "Rotate Clockwise",
	"action.rotate_texture_ccw": "Rotate Counter-clockwise",
	"action.predicate_overrides": "Edit Predicate Overrides...",
	"action.predicate_overrides.desc": "Select models to override this model based on selected conditions",
	"action.auto_set_cullfaces": "Set Cullfaces Automatically",
	"action.auto_set_cullfaces.desc": "Automatically generate cullfaces to hide faces when they are covered by the neighboring block.",
	"menu.texture.edit_externally": "Edit Externally",
	"menu.mirror_painting.texture": "2D Editor Symmetry",
	"menu.mirror_painting.texture.desc": "Enable mirror painting in 2D space on the image or texture",
	"menu.animator.rotation_global": "Rotate in Global Space",
	"uv_editor.face_properties": "Face Properties",
	"uv_editor.face_properties.material_instance": "Material Instance",
	"uv_editor.tint.info": "Tint can be enabled on a face to tell Minecraft to tint it. In vanilla, tint can only be used by specific blocks such as leaves and redstone dust, and can only have a value of 0.",
	"uv_editor.cullface.info": "Enabling cullface tells a face on a block to unrender if another full block is placed next to it in the specified direction in your Minecraft world. This can be used to optimize performance.",
	"uv_editor.material_instance.info": "Material instances can be set to a user-defined name. That name can be used in the block JSON file in the behavior pack to assign a particular texture and material that the face.",
	"display.reference.frame_invisible": "Item Frame (Invisible)",
	"data.settings_profile": "Profile",
	"message.display_skin.invalid_name": "Cannot find Minecraft account with the name \"%0\".",
	"dialog.load_plugins_from_query.title": "Load Plugins",
	"dialog.load_plugins_from_query.text": "You used a link that requires plugins to be installed. Would you like to install them?",
	"dialog.select_model.title": "Select Model",
	"dialog.select_model.bones": "Bones",
	"dialog.select_model.cubes": "Cubes",
	"dialog.settings.create_profile": "Create Profile...",
	"settings_profile.confirm_delete": "Are you sure you want to delete this settings profile?",
	"settings_profile.condition.type.selectable": "Manually Selectable",
	"settings.interface_mode": "UI Mode",
	"settings.interface_mode.desc": "Interface mode",
	"settings.interface_mode.auto": "Automatiskt",
	"settings.interface_mode.desktop": "Skrivbord",
	"settings.interface_mode.mobile": "Mobil",
	"settings.paint_through_transparency": "Paint Through Transparency",
	"settings.paint_through_transparency.desc": "Paint through transparent pixels when Lock Alpha Channel is enabled",
	"action.tab_overview": "Tab Overview",
	"action.tab_overview.desc": "View all open tabs in a grid and jump to one",
	"action.slider_color_red": "Color Red",
	"action.slider_color_green": "Color Green",
	"action.slider_color_blue": "Color Blue",
	"action.add_animation_controller": "Add Animation Controller",
	"action.add_animation_controller.desc": "Create a blank animation controller",
	"action.animation_controller_preview_mode": "Controller Preview",
	"action.animation_controller_preview_mode.paused": "Paused",
	"action.animation_controller_preview_mode.manual": "Manual Preview",
	"action.animation_controller_preview_mode.play": "Auto Play",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Länka Bézierhandtag",
	"action.keyframe_bezier_linked.desc": "Connect the right and left keyframe bézier handle",
	"action.reset_keyframe_handles": "Återställ nyckelbildshandtag",
	"action.reset_keyframe_handles.desc": "Reset the bézier handles of the selected keyframes",
	"action.looped_animation_playback": "Looped Playback",
	"action.looped_animation_playback.desc": "Preview animations in an infinite loop",
	"timeline.bind_to_actor": "Bind to Actor",
	"animation_controllers.select_preset": "Select a controller preset...",
	"animation_controllers.state.animations": "Animations",
	"animation_controllers.state.particles": "Particles",
	"animation_controllers.state.sounds": "Sounds",
	"animation_controllers.state.on_entry": "On Entry",
	"animation_controllers.state.on_exit": "On Exit",
	"animation_controllers.state.transitions": "Transitions",
	"animation_controllers.state.condition": "Condition",
	"animation_controllers.state.blend_transition": "Blend Time",
	"animation_controllers.state.shortest_path": "Blend by Shortest Path",
	"animation_controllers.state.edit_transition": "Edit Transition",
	"menu.color_picker.picker_type": "Picker Type",
	"menu.color_picker.picker_type.square": "Square",
	"menu.color_picker.picker_type.wheel": "Wheel",
	"menu.color_picker.slider_mode": "Slider Mode",
	"menu.color_picker.slider_mode.hsv": "Hue, Saturation, Value",
	"menu.color_picker.slider_mode.rgb": "Red, Green, Blue",
	"menu.texture.render_mode.additive": "Additive",
	"panel.color.picker_options": "Color Picker Options",
	"panel.animation_controllers": "Animation Controller",
	"display.preset.armor_stand": "Ground (Armor Stand)",
	"data.file_path": "File Path",
	"dialog.extrude.orientation": "Orientation",
	"dialog.extrude.orientation.upright": "Upright X",
	"dialog.extrude.orientation.flat": "Flat",
	"dialog.scale.box_uv_warning": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or switch to Per-face UV Mode in File > Project or per cube.",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Sequence",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.bg_image": "Background Image",
	"dialog.create_gif.turn.desc": "Rotate the model while recording. Use negative values to turn the model clockwise. A value of 60 corresponds to one rotation every second.",
	"settings_profile.condition": "Condition",
	"settings_profile.condition.type.file_path.desc": "Use Regular Expression syntax to match the file path of the current project. Use forward slashes for directories",
	"settings.only_selected_bezier_handles": "Show Only Selected Bézier Handles",
	"settings.only_selected_bezier_handles.desc": "Hide handles of bézier keyframes that are not currently selected",
	"settings.embed_textures": "Embed Textures",
	"settings.embed_textures.desc": "Embed texture file content in .bbmodel files",
	"action.selection_mode.cluster": "Cluster",
	"dialog.copied_to_clipboard": "Copied to clipboard",
	"data.reference_image": "Reference Image",
	"message.delete_reference_image": "Are you sure you want to delete this reference image? This cannot be undone.",
	"message.add_reference_image.message": "Select where to load the reference image",
	"message.import_particle_texture.import": "Import Particle Texture",
	"message.import_particle_texture.message": "Would you like to import a texture file to be used for your particle?",
	"message.save_codec_selector.title": "Save Model Format",
	"message.save_codec_selector.message": "Select a format to save the model in.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "Both",
	"message.display_skin.username": "Username (Java)",
	"message.palette_locked": "The palette is locked",
	"dialog.project.default_uv_mode": "Default UV Mode",
	"dialog.project.default_uv_mode.description": "Default UV Mode of the project. The UV mode can also be changed per cube.",
	"dialog.export_options.title": "Export Options",
	"dialog.edit_texture.preview": "Preview",
	"dialog.proportional_editing.range": "Range",
	"dialog.proportional_editing.falloff": "Falloff",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Smooth",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Selection",
	"dialog.proportional_editing.selection.linear": "Linear Distance",
	"dialog.proportional_editing.selection.connections": "Connections",
	"dialog.mirror_painting_texture_center.middle": "Middle",
	"dialog.mirror_painting_texture_center.custom": "Custom",
	"dialog.settings.reset_to_default": "Reset to Default",
	"keybindings.item.num_slider.increase": "Increase",
	"keybindings.item.num_slider.decrease": "Decrease",
	"settings.always_show_splash_art": "Always Show Splash Art",
	"settings.always_show_splash_art.desc": "Always display the splash art on the start screen",
	"action.slider_palette_color": "Switch Palette Color",
	"action.slider_palette_color.desc": "Cycle between the colors in the palette",
	"action.proportional_editing": "Proportional Editing",
	"action.proportional_editing.desc": "Proportionally affect surrounding vertices when editing parts of a mesh",
	"action.limit_to_palette": "Limit to Palette",
	"action.limit_to_palette.desc": "Limits the colors of the texture to those in the currently loaded palette",
	"action.edit_reference_images": "Edit Reference Images",
	"action.edit_reference_images.desc": "Turn on reference image mode to add or edit reference images and blueprints",
	"action.add_reference_image": "Add Reference Image",
	"action.reference_image_from_clipboard": "Paste Reference Image",
	"action.reference_image_list": "Reference Images",
	"action.connect_uv_faces": "Connect UV Faces",
	"action.connect_uv_faces.desc": "Connect the selected UV faces to the last selected UV face",
	"action.merge_uv_vertices": "Samanfoga UV-noder",
	"action.merge_uv_vertices.desc": "Snap the first selected UV vertices to the last selected UV vertices",
	"action.bedrock_animation_mode": "Bedrock Animation Mode",
	"action.bedrock_animation_mode.desc": "Select the mode to edit animations for Minecraft: Bedrock Edition in",
	"action.bedrock_animation_mode.entity": "Entitet",
	"action.bedrock_animation_mode.attachable_first": "Item 1st Person",
	"action.bedrock_animation_mode.attachable_third": "Item 3rd Person",
	"timeline.amplify": "Amplify",
	"menu.options": "Options...",
	"menu.palette.lock_palette": "Lock Palette",
	"menu.uv.export": "Export UV Mapping",
	"menu.uv.flip_x": "Mirror X",
	"menu.uv.flip_y": "Mirror Y",
	"menu.mirror_painting.enabled": "Enabled",
	"reference_image.position": "Position",
	"reference_image.size": "Size",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "Opacity",
	"reference_image.visibility": "Visibility",
	"reference_image.clear_mode": "Clear Mode",
	"reference_image.layer": "Layer",
	"reference_image.layer.background": "Behind Model",
	"reference_image.layer.viewport": "Above Model",
	"reference_image.layer.float": "Above Interface",
	"reference_image.scope": "Scope",
	"reference_image.scope.project": "Just this project",
	"reference_image.scope.global": "All projects",
	"reference_image.enabled_modes": "Enabled in Modes",
	"codec.common.encoding": "Encoding",
	"codec.common.armature": "Export Groups as Armature",
	"codec.common.export_animations": "Export Animations",
	"codec.common.embed_textures": "Embed Textures",
	"preview.center_camera": "Center Camera",
	"display.reference.frame_top": "Item Frame Top",
	"display.reference.frame_top_invisible": "Item Frame Top (Invisible)",
	"action.proportional_editing_range": "Proportional Editing Range",
	"action.proportional_editing_range.desc": "Adjust the range for proportional editing",
	"action.toggle_all_reference_images": "Hide/Show All Reference Images",
	"action.toggle_all_reference_images.desc": "Toggle the visibility of all reference images at once",
	"action.add_animation_controller_state": "Add Animation Controller State",
	"action.add_animation_controller_state.desc": "Add a new state to the animation controller",
	"menu.slider.round_value": "Round Value",
	"texture.error.too_large": "Resolution exceeds the maximum of %0",
	"dialog.copy_to_clipboard": "Copy to clipboard",
	"dialog.open_url": "Open URL",
	"reference_image.image": "Image",
	"uv_editor.rotate_uv": "Rotate UV",
	"generic.error": "Error",
	"projects.start_screen": "Start Screen",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.plugin_dependencies.title": "Plugin Dependencies",
	"message.plugin_dependencies.message1": "The plugin requires these dependencies:",
	"message.plugin_dependencies.message1_update": "The plugin %0 has been updated and now requires these dependencies:",
	"message.plugin_dependencies.message2": "Do you want to install them to continue?",
	"message.plugin_dependencies.invalid": "Unfortunately the plugin cannot be installed, it has an invalid dependency:",
	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",
	"dialog.convert_project.text1": "Convert the project into a different format.",
	"dialog.convert_project.text2": "Use conversion at your own risk. Formats have different features and restrictions, so converting will in some cases break parts of your project.",
	"dialog.convert_project.text3": "You cannot undo converting, that is why by default a copy will be created.",
	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "The following projects contain unsaved changes. Do you want to save your changes?",
	"dialog.unsaved_work.discard_all": "Discard All",
	"dialog.unsaved_work.save_all": "Save All",
	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Crop/Expand",
	"dialog.resize_texture.mode.scale": "Scale",
	"dialog.plugins.is_installed": "Installed",
	"dialog.plugins.is_disabled": "Disabled",
	"dialog.plugins.disable": "Disable",
	"dialog.plugins.enable": "Enable",
	"dialog.plugins.dependencies": "Depends on:",
	"dialog.view_backups.open_folder": "Open Folder",
	"dialog.share_model.reference_images": "Include Reference Images",
	"dialog.share_model.too_large": "Failed to upload: Model is too large",
	"dialog.share_model.too_large_references": "Failed to upload: Model is too large. Try without reference images.",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"edit.loop_cut.cuts": "Cuts",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "Layer",
	"data.panel": "Panel",
	"generic.confirm_delete": "Are you sure you want to delete this?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto nyckelbild",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.create_empty_layer": "Create Empty Layer",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Sammanfoga ner",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Visa en wireframe-vy av en annan bild i animationen som referens",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Återställ redigering",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Sammanfoga noder",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entitetklass",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Tillämpa",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Valda nyckelbilder",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Tjocklek",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Sammanfoga in i",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Sammanfoga animation",
	"action.merge_animation.desc": "Sammanfoga animationen in i en annan animation",
	"action.add_keyframe.reset_values": "With default values",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.reference.fox": "Fox",
	"display.reference.eating": "Eating",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_ocean": "Ocean",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Nyckelbilder",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "Extended Graph",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timeline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotera",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Riktning",
	"edit.extrude_mesh_selection.direction.outwards": "Utåt",
	"edit.extrude_mesh_selection.direction.average": "Genomsnitt",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Rikta",
	"edit.vertex_snap.align.longest": "Längsta axeln",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 axeln",
	"edit.vertex_snap.ignore_axis": "Ignorera axeln",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Polygonnät",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Polygonnät",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Sätt nodvikter",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Beräkna nodvikter",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Nodvikt",
	"action.view_mode.weighted_bone_colors": "Färger på nodben",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Skuggning",
	"mesh.shading.flat": "Platt",
	"mesh.shading.smooth": "Jämn",
	"spline_mesh.cyclic": "Cyklisk",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Vikt",
	"dialog.set_vertex_weights.overwrite": "Skriv över andra ben",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot",
	"data.generated_item_mesh": "Generated Item Model",
	"message.generated_item_model.title": "Generated Item Model",
	"message.generated_item_model.message": "This model has no elements of its own. Minecraft builds the item shape from the model's texture, so what you see here is only a preview of that shape. It cannot be edited, and is not exported.\n\nTo change how the item looks in game, edit the texture.",
	"message.generated_item_model.edit_texture": "Edit Texture",
	"message.generated_item_model.convert": "Convert to Editable Model",
	"message.convert_generated_item_model.title": "Convert to Editable Model",
	"message.convert_generated_item_model.message": "This builds real elements by extruding the texture, so you can change the item shape in 3D.\n\nIf you only want to change how the item looks, you do not need this. Edit the texture instead, and Minecraft will keep generating the shape from it.",
	"message.convert_generated_item_model.confirm": "Extrude Texture",
	"message.generated_item_model_conflict.title": "Generated Item Model",
	"message.generated_item_model_conflict.message": "Minecraft cannot use both a generated item model and elements. Now that this model has elements, the generated shape is ignored in game.",
	"message.generated_item_model_conflict.convert": "Convert the Generated Model to Cubes",
	"message.generated_item_model_conflict.convert.desc": "Extrude the texture into real elements, so nothing is lost",
	"message.generated_item_model_conflict.remove": "Remove the Generated Model",
	"message.generated_item_model_conflict.remove.desc": "Delete the preview and model the item from scratch",
	"message.generated_item_model_conflict.keep": "Keep It as a Reference",
	"message.generated_item_model_conflict.keep.desc": "Show it in Blockbench only, never exported",
	"message.add_reference_image.globally": "Add for all projects",
	"dialog.extrude.orientation.upright_z": "Upright Z",
	"dialog.extrude.depth": "Depth",
	"dialog.add_primitive.shape.icosphere": "Icosphere",
	"dialog.add_primitive.shape.octahedron": "Octahedron",
	"dialog.add_primitive.shape.dodecahedron": "Dodecahedron",
	"dialog.add_primitive.detail": "Detail",
	"dialog.plugins.update": "Update",
	"dialog.plugins.update_available": "Update Available",
	"dialog.create_variable_placeholder.variable": "Variable",
	"dialog.create_variable_placeholder.type": "Type",
	"dialog.create_variable_placeholder.type.value": "Value",
	"dialog.create_variable_placeholder.type.slider": "Slider",
	"dialog.create_variable_placeholder.type.toggle": "Toggle",
	"dialog.create_variable_placeholder.type.impulse": "Impulse",
	"dialog.create_variable_placeholder.value": "Value",
	"dialog.create_variable_placeholder.duration": "Duration",
	"dialog.create_variable_placeholder.step": "Step",
	"dialog.create_variable_placeholder.range": "Range",
	"dialog.create_variable_placeholder.output": "Output",
	"dialog.view_built_in_variables.function": "Parameters required",
	"dialog.advanced_screenshot.export": "Export",
	"dialog.preview_options.show_element_markers": "Show Element Markers",
	"dialog.preview_options.show_element_markers.desc": "Display markers to indicate the position for elements such as bones, null objects, and locators",
	"settings.maximum_zoom_distance": "Maximum Zoom Distance",
	"settings.maximum_zoom_distance.desc": "How far the camera can be zoomed away from the model",
	"settings.constant_outlines": "Constant Outlines",
	"settings.constant_outlines.desc": "Always display element outlines regardless of selection",
	"settings.new_project_dialog": "New Project Dialog",
	"settings.new_project_dialog.desc": "Show the Project dialog when creating a new project",
	"settings.opacity_range": "Opacity Range",
	"settings.opacity_range.desc": "Select which range is used to control opacity of layers and brushes",
	"settings.automatic_plugin_updates": "Automatic Plugin Updates",
	"settings.automatic_plugin_updates.desc": "Automatically update plugins to keep them up-to-date",
	"settings.native_window_frame": "Native Window Frame",
	"settings.native_window_frame.desc": "Use a native window frame in the style of the OS",
	"keybind.preview_scroll_pan": "Scroll Pan View",
	"keybind.preview_scroll_pan.desc": "Use scroll to pan the view, can be used for two-finger panning with trackpads",
	"action.position_slider_per_element": "Move Individual Positions",
	"action.position_slider_per_element.desc": "When enabled, using the position sliders changes individual positions per element. When disabled, the whole selection moves in the selected transform space.",
	"action.origin_slider_direct_values": "Move Pivot Values Directly",
	"action.origin_slider_direct_values.desc": "When enabled, pivot sliders will move the pivot point directly, affecting the position of the object. When disabled, positions get adjusted automatically.",
	"action.brush_lock_mode": "Brush Lock Mode",
	"action.brush_lock_mode.none": "Unlocked",
	"action.brush_lock_mode.element": "Lock to Element",
	"action.brush_lock_mode.face": "Lock to Face",
	"action.slider_brush_aspect_ratio": "Brush Aspect Ratio",
	"action.slider_brush_aspect_ratio.desc": "Aspect ratio of the brush",
	"action.screen_space_brush_projection": "Screen Space Brush Projection",
	"action.screen_space_brush_projection.desc": "Use screen space projection for painting with a brush",
	"action.close_other_projects": "Close Other Tabs",
	"action.close_other_projects.desc": "Closes all projects except the open project",
	"action.close_projects_to_right": "Close Tabs to the Right",
	"action.close_projects_to_right.desc": "Closes all project tabs to the right of the open project",
	"action.extrude_texture_to_model": "Extrude Texture",
	"action.extrude_texture_to_model.desc": "Generate a model by extruding this texture",
	"action.experimental_settings": "Experimental Settings",
	"action.experimental_settings.desc": "Customize experimental developer settings",
	"action.convert_texture_mesh_to_cubes": "Convert to Extruded Model",
	"action.convert_texture_mesh_to_cubes.desc": "Replace the texture mesh with cubes extruded from its texture, in the same place",
	"action.flip_in_place": "Flip in Place %0",
	"action.flip_in_place.desc": "Flip the selected elements on the %0 axis in its current position",
	"action.create_layer_group": "Create Layer Group",
	"action.resolve_layer_group": "Resolve Layer Group",
	"action.preview_models": "Preview Models",
	"action.preview_models.desc": "Select and edit reference models",
	"action.keyframe_select_before_playhead": "Select Keyframes Before Playhead",
	"action.keyframe_select_before_playhead.desc": "Select all keyframes in the timeline at or before the playhead",
	"action.keyframe_select_after_playhead": "Select Keyframes After Playhead",
	"action.keyframe_select_after_playhead.desc": "Select all keyframes in the timeline at or after the playhead",
	"action.set_ik_pole": "Set IK Pole",
	"action.set_ik_pole.desc": "Select the pole that the chain will attempt to face towards while moving",
	"action.create_variable_placeholder": "Create Variable Placeholder",
	"action.create_variable_placeholder.desc": "Add a variable to the variable placeholders list to preview a value",
	"action.view_built_in_variables": "View Built-in Variables",
	"action.view_built_in_variables.desc": "Display the list of variables and their values that Blockbench automatically provides for animation preview",
	"menu.paint": "Paint",
	"menu.brush_presets.screen_space": "Screen Space Brush",
	"edit.loop_cut.spacing": "Spacing",
	"edit.loop_cut.spacing.proportional": "Proportional",
	"edit.loop_cut.spacing.even_start": "Even - From Start",
	"edit.loop_cut.spacing.even_end": "Even - From End",
	"cube.shade_direction_override": "Shade Direction Override",
	"cube.shade_direction_override.desc": "Shade every face of the cube as if it was facing this direction. If not set, each face is shaded based on the direction it actually faces. This does not affect ambient occlusion or shading based on light level.",
	"null_object.ik_target": "IK Target",
	"null_object.ik_source": "IK Root",
	"null_object.ik_pole": "IK Pole",
	"reference_image.layer.scene": "3D Scene",
	"reference_image.view_mode": "View Mode",
	"reference_image.view_mode.flat_image": "Flat Image",
	"reference_image.cull_backface": "Hide Backside",
	"codec.common.merge_armature_mesh": "Merge Armature Mesh",
	"preview_model.transform": "Transform",
	"preview_model.reset_transform": "Reset Transform",
	"preview_model.minecraft_player": "Minecraft Player",
	"dialog.generate_pbr_map.channel": "PBR Channel",
	"dialog.generate_pbr_map.channel.metalness": "Metalness",
	"dialog.generate_pbr_map.channel.emissive": "Emissive",
	"dialog.generate_pbr_map.channel.roughness": "Roughness",
	"dialog.generate_pbr_map.method": "Source",
	"dialog.generate_pbr_map.method.value": "Value",
	"dialog.generate_pbr_map.method.brightness": "Brightness",
	"dialog.generate_pbr_map.method.saturation": "Saturation",
	"dialog.generate_pbr_map.method.hue": "Hue",
	"dialog.generate_pbr_map.method.red": "Red",
	"dialog.generate_pbr_map.method.green": "Green",
	"dialog.generate_pbr_map.method.blue": "Blue",
	"dialog.generate_pbr_map.method.empty": "Empty",
	"dialog.generate_pbr_map.in_range": "Input Range",
	"dialog.generate_pbr_map.out_range": "Output Range",
	"dialog.generate_pbr_map.invert": "Invert",
	"dialog.generate_pbr_map.preset": "Preset",
	"dialog.generate_pbr_map.preset.apply_preset": "Apply Preset",
	"dialog.generate_pbr_map.update_values": "Update with current values",
	"dialog.generate_pbr_map.preset.new_preset": "New Preset...",
	"action.image_editor_checkerboard": "Checkerboard",
	"action.image_editor_checkerboard.desc": "Toggle the checkerboard background of the 2D Editor",
	"message.child_model_only.resolve": "Resolve Parent Models",
	"message.child_model_only.resolve.desc": "Merge the whole parent chain into this model",
	"message.child_model_only.open.desc": "Open the parent in a new tab, keeping it separate from this model",
	"action.brush_lock_mode.selected_faces": "Lock to Selected Faces",
	"reference_image.view_mode.plane": "3D Plane",
	"preview_model.minecraft_crafting_table": "Minecraft Crafting Table",
	"dialog.extrude.animated": "Animated Texture",
	"dialog.scale.box_uv_warning_required": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or use Inflate.",
	"menu.color_picker.picker_type.wheel_static": "Wheel (Static)"
}